/*
 * Bisou Rivage — Atlas des tirages : globe (version ALT v3, 14/10/2026)
 * Points uniformes (sphères de Fibonacci) sur les terres Natural Earth 1:50m (domaine public),
 * trois densités qui se relaient avec le zoom. Rendu WebGL, repli en 2D si besoin.
 * Glisser pour tourner (avec élan), pincer ou ctrl + molette pour zoomer, « À plat » pour déplier
 * le globe (projection Equal Earth). Les repères proches se regroupent ; les toucher rapproche la vue.
 * Lieu précis : métachamps br_lat / br_lng. Sinon : centre du pays, avec un repère vide.
 */
(function () {
  'use strict';

  /* Terres : assets/bisou-carte-terres.js (chargé juste avant) */
  var LAND = window.BisouCarteTerres;
  if (!LAND || !LAND.layers || !LAND.layers.length) return;
  var DEG = Math.PI / 180, TAU = Math.PI * 2, PI = Math.PI;
  var GA = PI * (3 - Math.sqrt(5));
  var LAT_N = 83.5, LAT_S = -58.5; /* cadrage de la carte à plat */
  var AUTO = 4; /* rotation lente, en degrés par seconde */

  /* Equal Earth (Šavrič, Patterson, Jenny, 2018) */
  var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = Math.sqrt(3) / 2;
  function eeTh(phi) { return Math.asin(M * Math.sin(phi)); }
  function eeC(th) { var t2 = th * th, t6 = t2 * t2 * t2; return Math.cos(th) / (M * (A1 + 3 * A2 * t2 + t6 * (7 * A3 + 9 * A4 * t2))); }
  function eeY(th) { var t2 = th * th, t6 = t2 * t2 * t2; return th * (A1 + A2 * t2 + t6 * (A3 + A4 * t2)); }
  var EE_HALF_W = PI * eeC(0), EE_C0 = eeC(0);
  var Y_TOP = eeY(eeTh(LAT_N * DEG)), Y_BOT = eeY(eeTh(LAT_S * DEG)), Y_MID = (Y_TOP + Y_BOT) / 2;

  /* Centre approximatif des pays, pour les photos sans coordonnées */
  var C = {
    FR: [46.6, 2.4], ES: [40.2, -3.6], PT: [39.6, -8.0], IT: [42.8, 12.5], GB: [54.0, -2.0], IE: [53.2, -8.0],
    BE: [50.6, 4.6], NL: [52.2, 5.5], LU: [49.8, 6.1], DE: [51.2, 10.4], CH: [46.8, 8.2], AT: [47.6, 14.1],
    DK: [56.0, 10.0], NO: [61.5, 9.0], SE: [62.0, 15.5], FI: [64.0, 26.0], IS: [64.9, -18.6], PL: [52.0, 19.4],
    CZ: [49.8, 15.5], SK: [48.7, 19.7], HU: [47.2, 19.4], RO: [45.9, 24.9], BG: [42.7, 25.5], GR: [39.1, 22.0],
    HR: [45.1, 15.2], SI: [46.1, 14.8], RS: [44.0, 20.9], AL: [41.1, 20.0], ME: [42.7, 19.3], MK: [41.6, 21.7],
    BA: [44.2, 17.8], MT: [35.9, 14.4], CY: [35.1, 33.4], TR: [39.0, 35.2], UA: [49.0, 31.4], EE: [58.6, 25.0],
    LV: [56.9, 24.6], LT: [55.2, 23.9], MC: [43.7, 7.4], AD: [42.5, 1.5],
    MA: [31.8, -7.1], DZ: [28.0, 2.6], TN: [34.0, 9.5], EG: [26.6, 30.8], SN: [14.5, -14.5], CV: [15.1, -23.6],
    KE: [0.2, 37.9], TZ: [-6.4, 34.9], ZA: [-29.0, 25.0], NA: [-22.6, 17.1], MG: [-18.8, 46.9], MU: [-20.3, 57.6],
    RE: [-21.1, 55.5], SC: [-4.7, 55.5], ET: [9.1, 40.5], GH: [7.9, -1.0], CI: [7.5, -5.5],
    IL: [31.4, 35.0], JO: [31.2, 36.5], LB: [33.9, 35.9], SA: [24.0, 45.0], AE: [24.0, 54.0], OM: [21.5, 57.0],
    QA: [25.3, 51.2], IR: [32.4, 53.7], GE: [42.3, 43.4], AM: [40.1, 45.0], AZ: [40.1, 47.6],
    KZ: [48.0, 67.0], UZ: [41.4, 64.6], KG: [41.4, 74.6], TJ: [38.9, 71.3], MN: [46.8, 103.8], CN: [35.9, 104.2],
    HK: [22.3, 114.2], TW: [23.7, 121.0], JP: [36.2, 138.3], KR: [36.5, 127.9], IN: [22.4, 79.0], NP: [28.3, 84.1],
    BT: [27.5, 90.4], LK: [7.9, 80.8], MV: [3.2, 73.2], TH: [15.1, 101.0], VN: [15.9, 105.8], LA: [18.2, 103.9],
    KH: [12.6, 104.9], MM: [21.9, 96.0], MY: [4.2, 101.9], SG: [1.35, 103.8], ID: [-2.5, 118.0], PH: [12.9, 122.0],
    AU: [-25.7, 134.5], NZ: [-41.5, 172.8], PF: [-17.7, -149.4], NC: [-21.3, 165.6], RU: [56.0, 40.0],
    US: [39.8, -98.6], CA: [56.1, -106.3], MX: [23.6, -102.5], CU: [21.5, -79.5], GP: [16.2, -61.6],
    MQ: [14.6, -61.0], CR: [9.7, -84.0], PA: [8.5, -80.1], CO: [4.6, -74.3], PE: [-9.2, -75.0], BO: [-16.3, -63.6],
    CL: [-35.7, -71.5], AR: [-38.4, -63.6], UY: [-32.5, -55.8], BR: [-10.8, -52.9], EC: [-1.8, -78.2], VE: [6.4, -66.6]
  };

  /* Zones : boîte [lng min, lat min, lng max, lat max] pour le compte, et vue (centre, zoom) */
  var ZONES = [
    { k: 'monde', box: null, lon: 12, lat: 24, zoom: 1 },
    { k: 'europe', box: [-12, 29, 34, 61], lon: 6, lat: 45, zoom: 2.4 },
    { k: 'asie', box: [58, -11, 148, 54], lon: 104, lat: 25, zoom: 1.5 },
    { k: 'ameriques', box: [-126, -46, -32, 60], lon: -70, lat: 2, zoom: 1.25 },
    { k: 'afrique', box: [-20, -36, 60, 38], lon: 26, lat: 12, zoom: 1.45 }
  ];

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function wrapRad(a) { a = (a + PI) % TAU; if (a < 0) a += TAU; return a - PI; }
  function wrapDeg(a) { a = (a + 180) % 360; if (a < 0) a += 360; return a - 180; }
  function ease(k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; }
  function easeOut(k) { return 1 - Math.pow(1 - k, 3); }
  function smooth(e0, e1, x) { var k = clamp((x - e0) / (e1 - e0), 0, 1); return k * k * (3 - 2 * k); }
  function num(v) { var n = typeof v === 'number' ? v : parseFloat(v); return isFinite(n) ? n : null; }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function money(cents) {
    var whole = Math.floor((cents || 0) / 100), rest = (cents || 0) % 100;
    var t = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (rest) t += ',' + (rest < 10 ? '0' : '') + rest;
    return t + ' €';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var regionNames = null;
  try { regionNames = new Intl.DisplayNames([document.documentElement.lang || 'fr', 'fr'], { type: 'region' }); } catch (e) { regionNames = null; }
  function countryName(cc) {
    if (!cc) return '';
    try { return regionNames ? regionNames.of(String(cc).toUpperCase()) : cc; } catch (e) { return cc; }
  }
  /* Langues (27/10) : un nombre et son mot (« 1 photo », « 3 photos ») ; un compteur japonais se colle au nombre
     (3枚, 2か所), et un titre d'œuvre se met entre 「」 (« » en espagnol, “ ” sinon). */
  var LANG2 = String(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var PHOTO1 = ({ es: 'foto', ja: '' })[LANG2];
  if (PHOTO1 == null) PHOTO1 = 'photo';
  function nb(n, plural, one) { var w = n > 1 || !one ? plural : one; return n + (/^[\u3000-\u9fff]/.test(w) ? '' : ' ') + w; }
  function quoted(t) { return LANG2 === 'ja' ? '「' + t + '」' : LANG2 === 'es' ? '«' + t + '»' : '“' + t + '”'; }
  /* Drapeau d'un pays : la paire d'indicateurs régionaux de son code ISO-2 (FR → 🇫🇷).
     Sous Windows, c'est la police « BR Flags » du thème qui le peint : la balise doit
     porter la classe .br-flag (layout/theme.liquid), sinon on lit « FR ». */
  function flag(cc) {
    cc = String(cc || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(cc)) return '';
    return String.fromCodePoint(0x1F1E6 + cc.charCodeAt(0) - 65, 0x1F1E6 + cc.charCodeAt(1) - 65);
  }

  /* ---------- Couches de points, décodées à la demande ----------
     Chaque point : sin φ, cos φ, λ, puis les coefficients Equal Earth (c, y). */
  var LAYERS = LAND.layers.map(function (l) {
    return { n: l.n, rle: l.rle, ang: Math.sqrt(4 * PI / l.n), pts: null };
  }).sort(function (a, b) { return a.n - b.n; });

  /* Masque terre / mer : séries alternées (mer, terre…) dans l'ordre des bandes de latitude,
     chaque bande triée par longitude (le même ordre que le générateur, calcul pour calcul). */
  function landIdx(L) {
    var N = L.n, K = Math.round(Math.sqrt(N * PI) / 2), bin = atob(L.rle), runs = [], p = 0, i;
    while (p < bin.length) {
      var v = 0, mul = 1, byte;
      do { byte = bin.charCodeAt(p++); v += (byte & 127) * mul; mul *= 128; } while ((byte & 128) && p < bin.length);
      runs.push(v);
    }
    var order = new Int32Array(N), o = 0, start = 0, cur = -1, SH = 1 << 12, Q = Math.pow(2, 28);
    /* Tri par longitude dans la bande : clé numérique (longitude puis rang), triée nativement */
    function flush(end) {
      var len = end - start, key = new Float64Array(len), k;
      for (k = 0; k < len; k++) key[k] = Math.floor((((start + k) * GA) % TAU) * Q) * SH + k;
      key.sort();
      for (k = 0; k < len; k++) order[o++] = start + (key[k] % SH);
    }
    for (i = 0; i < N; i++) {
      var z = 1 - (2 * i + 1) / N, b = Math.min(K - 1, Math.floor((1 - z) * K / 2));
      if (b !== cur) { if (cur !== -1) flush(i); start = i; cur = b; }
    }
    flush(N);
    var idx = [], at = 0, land = false;
    for (var r = 0; r < runs.length; r++) {
      if (land) for (var q = 0; q < runs[r] && at + q < N; q++) idx.push(order[at + q]);
      at += runs[r];
      land = !land;
    }
    return idx.sort(function (x, y) { return x - y; });
  }

  /* Canevas de l'atlas : méridiens tous les 30°, équateur et parallèles, en pointillés très légers */
  var GRID = { n: 'grid', ang: 0, pts: null, grid: true };
  function gridPts() {
    if (GRID.pts) return GRID.pts;
    var out = [], step = 1.5, lat, lon;
    function push(la, lo) {
      var phi = la * DEG, th = eeTh(phi);
      out.push(Math.sin(phi), Math.cos(phi), wrapRad(lo * DEG), eeC(th), eeY(th));
    }
    for (lon = -180; lon < 180; lon += 30) for (lat = -60; lat <= 80; lat += step) push(lat, lon);
    [-30, 0, 30, 60].forEach(function (la) { for (lon = -180; lon < 180; lon += step) push(la, lon); });
    GRID.pts = { n: out.length / 5, d: new Float32Array(out) };
    return GRID.pts;
  }

  function decode(L) {
    if (L.grid) return gridPts();
    if (L.pts) return L.pts;
    var idx = landIdx(L), N = L.n;
    var n = idx.length, d = new Float32Array(n * 5);
    for (var k = 0, o = 0; k < n; k++, o += 5) {
      var j = idx[k], z = 1 - (2 * j + 1) / N, phi = Math.asin(z), lam = (j * GA) % TAU;
      if (lam > PI) lam -= TAU;
      var th = eeTh(phi);
      d[o] = z; d[o + 1] = Math.cos(phi); d[o + 2] = lam; d[o + 3] = eeC(th); d[o + 4] = eeY(th);
    }
    L.pts = { n: n, d: d };
    return L.pts;
  }

  /* ---------- Rendu WebGL des points et de la sphère ---------- */
  var FP = '#ifdef GL_FRAGMENT_PRECISION_HIGH\nprecision highp float;\n#else\nprecision mediump float;\n#endif\n';
  var DOT_VS = [
    'precision highp float;',
    'attribute vec4 a_p;',
    'attribute float a_y;',
    'uniform vec2 u_res;',
    'uniform vec2 u_c;',
    'uniform vec4 u_v;',
    'uniform vec3 u_s;',
    'uniform vec4 u_d;',
    'uniform vec3 u_b;',
    'varying float v_a;',
    'varying float v_r;',
    'void main() {',
    '  float dl = mod(a_p.z - u_v.x + 3.14159265, 6.28318531) - 3.14159265;',
    '  float cd = cos(dl);',
    '  float z = u_v.y * a_p.x + u_v.z * a_p.y * cd;',
    '  vec2 g = vec2(u_c.x + u_s.x * a_p.y * sin(dl), u_c.y - u_s.x * (u_v.z * a_p.x - u_v.y * a_p.y * cd));',
    '  vec2 f = vec2(u_c.x + u_s.y * a_p.w * dl, u_c.y - u_s.y * (a_y - u_s.z));',
    '  vec2 p = mix(g, f, u_v.w);',
    '  float zf = max(z, 0.0);',
    '  float lim = smoothstep(0.04, 0.95, zf);',
    '  float fr = step(0.0, z);',
    '  float a = mix(mix(u_b.x, u_b.y + u_b.z * lim, fr), 0.6, u_v.w);',
    '  float r = u_d.x * mix(mix(0.5, 0.3 + 0.7 * zf, fr), 1.0, u_v.w) * u_d.z;',
    '  float rr = max(r, 0.75);',
    '  v_a = a * u_d.y * min(1.0, (r * r) / (rr * rr));',
    '  v_r = rr;',
    '  gl_PointSize = 2.0 * rr + 2.0;',
    '  gl_Position = vec4(p.x / u_res.x * 2.0 - 1.0, 1.0 - p.y / u_res.y * 2.0, 0.0, 1.0);',
    '}'
  ].join('\n');
  var DOT_FS = FP + [
    'uniform vec3 u_ink;',
    'varying float v_a;',
    'varying float v_r;',
    'void main() {',
    '  float d = length(gl_PointCoord - 0.5) * (2.0 * v_r + 2.0);',
    '  float a = v_a * clamp(v_r - d + 0.5, 0.0, 1.0);',
    '  if (a < 0.004) discard;',
    '  gl_FragColor = vec4(u_ink * a, a);',
    '}'
  ].join('\n');
  var DISC_VS = 'attribute vec2 a_q;\nvoid main() { gl_Position = vec4(a_q, 0.0, 1.0); }';
  var DISC_FS = FP + [
    'uniform vec3 u_ink;',
    'uniform vec4 u_k;',
    'uniform vec4 u_f;',
    'uniform float u_px;',
    'void main() {',
    '  vec2 q = (gl_FragCoord.xy - u_k.xy) / u_k.z;',
    '  float R = u_k.z, r = length(q), d = r * R;',
    '  float inside = clamp(R - d + 0.5, 0.0, 1.0);',
    /* Lumière douce venue d'en haut à gauche : le globe prend du volume sans reflet brillant */
    '  float nz = sqrt(max(0.0, 1.0 - r * r));',
    '  float l = dot(vec3(q, nz), vec3(-0.42, 0.52, 0.744));',
    '  float fill = (u_f.x + u_f.y * (1.0 - smoothstep(-0.35, 1.0, l)) + 0.018 * smoothstep(0.82, 1.0, r)) * inside;',
    '  float ring = clamp(1.0 - abs(d - R + 0.5 * u_px) / u_px, 0.0, 1.0) * u_f.z;',
    '  float halo = (1.0 - inside) * u_f.w * (1.0 - smoothstep(R, R + 22.0 * u_px, d));',
    '  float a = min(1.0, fill + ring + halo) * u_k.w;',
    '  if (a < 0.002) discard;',
    '  gl_FragColor = vec4(u_ink * a, a);',
    '}'
  ].join('\n');

  function GLDots(canvas, ink) {
    var o = { alpha: true, antialias: false, depth: false, stencil: false, premultipliedAlpha: true, preserveDrawingBuffer: false };
    var gl = null;
    try { gl = canvas.getContext('webgl', o) || canvas.getContext('experimental-webgl', o); } catch (e) { gl = null; }
    if (!gl || typeof gl.createShader !== 'function') return null;
    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s) || 'shader');
      return s;
    }
    function link(vs, fs, attrs) {
      var p = gl.createProgram();
      gl.attachShader(p, compile(gl.VERTEX_SHADER, vs));
      gl.attachShader(p, compile(gl.FRAGMENT_SHADER, fs));
      attrs.forEach(function (a, i) { gl.bindAttribLocation(p, i, a); });
      gl.linkProgram(p);
      if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p) || 'link');
      var u = {}, n = gl.getProgramParameter(p, gl.ACTIVE_UNIFORMS);
      for (var i = 0; i < n; i++) { var info = gl.getActiveUniform(p, i); u[info.name] = gl.getUniformLocation(p, info.name); }
      return { p: p, u: function (k) { return u[k] || null; } };
    }
    var pd, pc;
    try { pd = link(DOT_VS, DOT_FS, ['a_p', 'a_y']); pc = link(DISC_VS, DISC_FS, ['a_q']); } catch (e) {
      if (window.console) console.warn('[bcm] webgl', e);
      return null;
    }
    var quad = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, quad);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var bufs = {};
    function buffer(L) {
      if (bufs[L.n]) return bufs[L.n];
      var P = decode(L), b = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, b);
      gl.bufferData(gl.ARRAY_BUFFER, P.d, gl.STATIC_DRAW);
      bufs[L.n] = { b: b, n: P.n };
      return bufs[L.n];
    }
    return {
      resize: function (w, h) {
        if (canvas.width !== w) canvas.width = w;
        if (canvas.height !== h) canvas.height = h;
      },
      draw: function (S) {
        if (gl.isContextLost && gl.isContextLost()) return;
        var k = canvas.width / S.W;
        gl.viewport(0, 0, canvas.width, canvas.height);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        if (S.disc > 0.003) {
          gl.useProgram(pc.p);
          gl.bindBuffer(gl.ARRAY_BUFFER, quad);
          gl.enableVertexAttribArray(0);
          gl.disableVertexAttribArray(1);
          gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
          gl.uniform3fv(pc.u('u_ink'), ink);
          gl.uniform4f(pc.u('u_k'), S.cx * k, (S.H - S.cy) * k, S.R * k, S.disc);
          gl.uniform4f(pc.u('u_f'), 0.012 * S.fill, 0.068 * S.fill, 0.12, 0.035);
          gl.uniform1f(pc.u('u_px'), k);
          gl.drawArrays(gl.TRIANGLES, 0, 3);
        }
        gl.useProgram(pd.p);
        gl.uniform3fv(pd.u('u_ink'), ink);
        gl.uniform2f(pd.u('u_res'), S.W, S.H);
        gl.uniform2f(pd.u('u_c'), S.cx, S.cy);
        gl.uniform4f(pd.u('u_v'), S.lam0, S.sp0, S.cp0, S.t);
        gl.uniform3f(pd.u('u_s'), S.R, S.F, S.yc);
        gl.uniform3f(pd.u('u_b'), S.back, 0.05, 0.82);
        gl.enableVertexAttribArray(0);
        gl.enableVertexAttribArray(1);
        S.layers.forEach(function (it) {
          var b = buffer(it.L);
          gl.bindBuffer(gl.ARRAY_BUFFER, b.b);
          gl.vertexAttribPointer(0, 4, gl.FLOAT, false, 20, 0);
          gl.vertexAttribPointer(1, 1, gl.FLOAT, false, 20, 16);
          gl.uniform4f(pd.u('u_d'), it.r, S.alpha * it.w, k, 0);
          gl.drawArrays(gl.POINTS, 0, b.n);
        });
      }
    };
  }

  function init(root) {
    var dataEl = root.querySelector('[data-bcm-data]');
    var cfgEl = root.querySelector('[data-bcm-cfg]');
    var frame = root.querySelector('[data-bcm-frame]');
    var canvas = root.querySelector('[data-bcm-canvas]');
    var cartel = root.querySelector('[data-bcm-cartel]');
    var zonesBox = root.querySelector('[data-bcm-zones]');
    var viewsBox = root.querySelector('[data-bcm-views]');
    var indexBox = root.querySelector('[data-bcm-index]');
    var countEl = root.querySelector('[data-bcm-count]');
    var hintEl = root.querySelector('[data-bcm-hint]');
    var isHome = root.classList.contains('bcm--home');
    if (!dataEl || !canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var items, cfg = {};
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { cfg = {}; }
    /* La touche qui, avec la molette, zoome : ⌘ sur Mac, Ctrl ailleurs */
    var KEY = /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '') ? '⌘' : 'Ctrl';
    var zoneLabels = String(cfg.zones || '').split('|');
    function mq(q) { try { return window.matchMedia ? window.matchMedia(q) : null; } catch (e) { return null; } }
    var mqReduce = mq('(prefers-reduced-motion: reduce)'), mqSmall = mq('(max-width: 749px)'), mqTouch = mq('(hover: none) and (pointer: coarse)');
    var reduce = !!(mqReduce && mqReduce.matches);

    /* Encre : la couleur du texte du thème ; papier : celle du fond, sous les repères et les étiquettes.
       26/10 (a26-atlas-bugs, Max : « parfois il est jaune […] on le voit presque pas ») : en sombre, l'encre crème
       se posait sur des carrés blancs ; et l'encre lue une seule fois restait celle du thème d'arrivée. Elle se relit
       quand le thème change (classe de <html>, réglage de l'appareil). */
    var ink = [17, 17, 17], inkF = [17 / 255, 17 / 255, 17 / 255], INK = 'rgb(17,17,17)', paper = [255, 255, 255], PAPER = '#fff';
    function rgbVar(st, name) {
      var v = String(st.getPropertyValue(name) || '').split(',').map(parseFloat);
      return v.length === 3 && v.every(function (n) { return isFinite(n); }) ? v : null;
    }
    function readInk() {
      try {
        var st = getComputedStyle(root), fg = rgbVar(st, '--color-foreground'), bg = rgbVar(st, '--color-background');
        if (fg) for (var i = 0; i < 3; i++) { ink[i] = fg[i]; inkF[i] = fg[i] / 255; }
        paper = bg || [255, 255, 255];
      } catch (e) { /* encre par défaut */ }
      var was = INK + PAPER;
      INK = 'rgb(' + ink.join(',') + ')';
      PAPER = 'rgb(' + paper.join(',') + ')';
      return was !== INK + PAPER;
    }
    readInk();
    function reInk() { if (readInk()) kick(); }
    try { new MutationObserver(reInk).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme'] }); } catch (e) { /* sans observateur */ }
    var mqDark = mq('(prefers-color-scheme: dark)');
    if (mqDark) { if (mqDark.addEventListener) mqDark.addEventListener('change', reInk); else if (mqDark.addListener) mqDark.addListener(reInk); }

    /* Le globe en WebGL, sous le canevas des repères ; sans WebGL, tout est dessiné en 2D */
    var glCanvas = null, glr = null;
    function dropGL() {
      glr = null;
      if (glCanvas && glCanvas.parentNode) glCanvas.parentNode.removeChild(glCanvas);
      glCanvas = null;
      root.classList.remove('is-gl');
    }
    if (cfg.webgl !== false && window.WebGLRenderingContext) {
      glCanvas = document.createElement('canvas');
      glCanvas.className = 'bcm__gl';
      glCanvas.setAttribute('aria-hidden', 'true');
      canvas.parentNode.insertBefore(glCanvas, canvas);
      try { glr = GLDots(glCanvas, inkF); } catch (e) { glr = null; }
      if (!glr) dropGL();
      else {
        root.classList.add('is-gl');
        glCanvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); dropGL(); clusterScale = 0; kick(); }, false);
      }
    }

    /* 1. Regrouper les photos par lieu */
    var groups = [], byKey = {}, countries = {};
    items.forEach(function (it) {
      var la = num(it.la), lo = num(it.lo), cc = it.cc ? String(it.cc).toUpperCase() : '';
      var exact = la != null && lo != null;
      if (!exact) {
        if (!cc || !C[cc]) return;
        la = C[cc][0]; lo = C[cc][1];
      }
      it.lat = la; it.lng = lo; it.exact = exact; it.cc = cc;
      it.country = countryName(cc);
      if (cc) countries[cc] = (countries[cc] || 0) + 1;
      var key = exact ? la.toFixed(2) + ',' + lo.toFixed(2) : 'pays:' + cc;
      it.key = key;
      var g = byKey[key];
      if (!g) {
        var phi = la * DEG, th = eeTh(phi), lam = lo * DEG;
        g = byKey[key] = {
          key: key, lat: la, lng: lo, sp: Math.sin(phi), cp: Math.cos(phi), fc: eeC(th), fy: eeY(th),
          ux: Math.cos(phi) * Math.cos(lam), uy: Math.cos(phi) * Math.sin(lam), uz: Math.sin(phi),
          items: [], exact: exact, label: ''
        };
        groups.push(g);
      }
      g.items.push(it);
    });
    function placeLabel(it) {
      var parts = [];
      if (it.c) parts.push(it.c);
      if (it.country && it.country !== it.c) parts.push(it.country);
      /* Langues (28/10) : en japonais, la ville et le pays se séparent par 「、」 (« アブダビ、アラブ首長国連邦 ») */
      return parts.join(LANG2 === 'ja' ? '、' : ', ');
    }
    /* Version courte : la ville quand le lieu est précis, sinon le pays */
    function shortPlace(it) { return (it.exact && it.c) || it.country || ''; }
    groups.forEach(function (g) { g.label = g.exact ? placeLabel(g.items[0]) : g.items[0].country; });
    var placed = groups.reduce(function (n, g) { return n + g.items.length; }, 0);
    if (countEl) countEl.textContent = String(cfg.count || '[n] tirages · [p] pays').replace('[n]', placed).replace('[p]', Object.keys(countries).length);
    /* Accueil (v5, 21/10) : les drapeaux des pays de l'Atlas, du plus fourni au moins fourni ; le nom du pays au survol */
    var flagsEl = root.querySelector('[data-bcm-flags]');
    if (flagsEl) {
      Object.keys(countries).sort(function (a, b) {
        return (countries[b] - countries[a]) || countryName(a).localeCompare(countryName(b), 'fr');
      }).forEach(function (cc) {
        var fl = flag(cc);
        if (!fl) return;
        var f = el('i', 'bcm__flag br-flag', fl);
        f.title = countryName(cc);
        f.setAttribute('data-cc', cc);
        flagsEl.appendChild(f);
      });
    }

    /* Légende : chaque type de repère n'apparaît que s'il sert */
    var kinds = { exact: false, country: false, group: false };
    groups.forEach(function (g) { kinds[g.exact ? 'exact' : 'country'] = true; if (g.items.length > 1) kinds.group = true; });
    root.querySelectorAll('[data-bcm-key]').forEach(function (n) { n.hidden = !kinds[n.getAttribute('data-bcm-key')]; });

    /* Repères proches à l'écran : regroupés (distance sur la sphère, donc stable quand le globe tourne) */
    function ang(a, b) { return Math.acos(clamp(a.ux * b.ux + a.uy * b.uy + a.uz * b.uz, -1, 1)); }
    var clusters = [], clusterScale = 0, small = false;
    function buildClusters(ppr) {
      var thr = (small ? 26 : 21) / Math.max(1, ppr);
      var list = groups.slice().sort(function (a, b) { return (b.items.length - a.items.length) || ((b.exact ? 1 : 0) - (a.exact ? 1 : 0)); });
      var out = [];
      list.forEach(function (g) {
        var best = null, bd = thr;
        out.forEach(function (c) { var d = ang(c.head, g); if (d < bd) { bd = d; best = c; } });
        if (best) { best.members.push(g); best.n += g.items.length; best.exact = best.exact || g.exact; }
        else out.push({ key: g.key, head: g, members: [g], n: g.items.length, exact: g.exact, sx: 0, sy: 0, z: 0, a: 0, k: 1, s: 0 });
      });
      clusters = out;
      clusterScale = ppr;
    }

    /* 2. Vue : centre (lon, lat), zoom, dépliage t (0 = globe, 1 = à plat), décalage horizontal ox */
    var view = { lon: ZONES[0].lon, lat: ZONES[0].lat, zoom: 1, t: 0, ox: 0 };
    var mode = 'globe', tween = null, vel = { lon: 0, lat: 0 };
    var W = 0, H = 0, dpr = 1;
    var lastUser = -1e9, inView = false, raf = 0, lastTs = 0, autoTimer = 0;
    var gesture = null, ptrs = {}, nPtr = 0, lonAcc = 0, downRect = null;
    var sel = null, hover = null, hot = null, pulse = 0, before = null;
    var introStart = 0, introDone = reduce, isZoomed = false;
    var cartelBox = null;

    /* Zoom maximal : tant que les points les plus fins restent serrés (écart d'environ 5 px au plus) */
    function maxZoom() { return mode === 'flat' ? clamp(720 / Math.max(1, baseF()), 2.6, 6) : clamp(620 / Math.max(1, baseR()), 2.6, 4); }
    /* À plat et zoomé, le bord nord ou sud de la carte ne descend pas dans le cadre (comme sur une carte classique) ;
       si la carte est moins haute que le cadre, elle reste centrée. */
    function latOfY(y) {
      var lo = -PI / 2, hi = PI / 2, i, mid;
      for (i = 0; i < 40; i++) { mid = (lo + hi) / 2; if (eeY(eeTh(mid)) < y) lo = mid; else hi = mid; }
      return (lo + hi) / 2 / DEG;
    }
    function flatRange(zoom) {
      var s = smooth(1, 1.5, zoom), half = (H / 2) / Math.max(1, baseF() * zoom);
      var lo = Y_BOT + half, hi = Y_TOP - half;
      if (lo > hi) lo = hi = Y_MID;
      if (s < 0.001) return [-50, 70];
      return [Math.max(-50, latOfY(Y_MID + (lo - Y_MID) / s)), Math.min(70, latOfY(Y_MID + (hi - Y_MID) / s))];
    }
    function latMin(z) { return mode === 'flat' ? flatRange(z == null ? view.zoom : z)[0] : -60; }
    function latMax(z) { return mode === 'flat' ? flatRange(z == null ? view.zoom : z)[1] : 72; }
    function baseR() { return Math.min(W, H) * (small ? 0.45 : 0.44); }
    function baseF() {
      var fitW = (W * 0.95) / (2 * EE_HALF_W), fitH = (H * (small ? (isHome ? 0.7 : 0.8) : 0.88)) / (Y_TOP - Y_BOT);
      /* Téléphone : la carte à plat déborde un peu sur les côtés (on la fait glisser) plutôt que d'être minuscule ;
         page de l'Atlas (v4, revue téléphone, défaut 9) : plus grande, moins de blanc au-dessus et au-dessous */
      return Math.min(small ? fitW * (isHome ? 1.35 : 1.7) : fitW, fitH);
    }
    function geom() {
      var k = view.zoom, t = ease(clamp(view.t, 0, 1));
      var R = baseR() * k, F = baseF() * k, phi0 = view.lat * DEG;
      var yc = Y_MID + (eeY(eeTh(phi0)) - Y_MID) * smooth(1, 1.5, k), half = (H / 2) / Math.max(1, F);
      /* Pendant une animation, la latitude peut dépasser un instant : le dessin, lui, ne montre jamais le vide au-delà des bords */
      if (t > 0) yc = Y_BOT + half > Y_TOP - half ? Y_MID : clamp(yc, Y_BOT + half, Y_TOP - half);
      return {
        R: R, F: F, t: t, cx: W / 2 + view.ox, cy: H / 2,
        lam0: view.lon * DEG, sp0: Math.sin(phi0), cp0: Math.cos(phi0),
        yc: yc,
        ppr: R + (F - R) * t
      };
    }

    /* Position à l'écran d'un point (sin φ, cos φ, λ, coefficients Equal Earth) */
    function project(G, sp, cp, lam, fc, fy, out) {
      var dl = wrapRad(lam - G.lam0), cd = Math.cos(dl);
      var z = G.sp0 * sp + G.cp0 * cp * cd;
      var gx = G.cx + G.R * cp * Math.sin(dl), gy = G.cy - G.R * (G.cp0 * sp - G.sp0 * cp * cd);
      if (G.t <= 0) { out.x = gx; out.y = gy; out.z = z; return; }
      var fx = G.cx + G.F * fc * dl, fy2 = G.cy - G.F * (fy - G.yc);
      out.x = gx + (fx - gx) * G.t; out.y = gy + (fy2 - gy) * G.t; out.z = z;
    }

    /* Densité : on garde un écart régulier entre les points, quel que soit le zoom */
    function layerMix(G) {
      var target = small ? 3.2 : 4.4;
      var f = clamp(Math.log((LAYERS[0].ang * G.ppr) / target) / Math.LN2, 0, LAYERS.length - 1);
      var i = Math.min(LAYERS.length - 1, Math.floor(f)), w1 = i + 1 < LAYERS.length ? smooth(0.3, 0.7, f - i) : 0;
      var out = [];
      if (1 - w1 > 0.01) out.push({ L: LAYERS[i], w: 1 - w1 });
      if (w1 > 0.01) out.push({ L: LAYERS[i + 1], w: w1 });
      out.forEach(function (o) { o.r = clamp(o.L.ang * G.ppr * 0.27, 0.6, 2.3); });
      return out;
    }

    function introAlpha(ts) {
      if (introDone && !introStart) return 1;
      if (!introStart) return 0;
      var k = clamp((ts - introStart) / 900, 0, 1);
      if (k >= 1) { introStart = 0; introDone = true; }
      return easeOut(k);
    }

    /* 3. Dessin */
    var tmp = { x: 0, y: 0, z: 0 };
    function render(ts) {
      if (!W || !H) return;
      if (mode === 'flat' && view.t >= 1) view.lat = clamp(view.lat, latMin(), latMax());
      var G = geom(), ia = introAlpha(ts);
      if (!clusterScale || Math.abs(G.ppr / clusterScale - 1) > 0.06) buildClusters(G.ppr);
      var zoomed = view.zoom > 1.3 || (mode === 'flat' && small);
      if (zoomed !== isZoomed) { isZoomed = zoomed; root.classList.toggle('is-zoomed', zoomed); }
      if (glr) {
        glr.draw({
          W: W, H: H, cx: G.cx, cy: G.cy, R: G.R, F: G.F, yc: G.yc, lam0: G.lam0, sp0: G.sp0, cp0: G.cp0, t: G.t,
          disc: (1 - G.t) * ia, fill: 1 - smooth(1.35, 2.2, view.zoom), alpha: ia,
          back: 0.04 * (1 - G.t) * (1 - smooth(1.15, 1.7, view.zoom)),
          layers: cfg.grid === false ? layerMix(G) : layerMix(G).concat([{ L: GRID, w: 0.2, r: 0.55 }])
        });
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      if (!glr) draw2D(G, ia);
      drawMarkers(G, ia, ts);
    }

    /* Repli sans WebGL : la couche la plus utile, en petits carrés */
    function draw2D(G, ia) {
      var mix = layerMix(G), best = mix[0];
      mix.forEach(function (m) { if (m.w > best.w) best = m; });
      var P = decode(best.L), d = P.d, t = G.t, r = best.r;
      if (t < 1) {
        ctx.globalAlpha = (1 - t) * ia;
        var gr = ctx.createRadialGradient(G.cx, G.cy, G.R * 0.3, G.cx, G.cy, G.R);
        gr.addColorStop(0, 'rgba(' + ink.join(',') + ',.024)'); gr.addColorStop(1, 'rgba(' + ink.join(',') + ',.062)');
        ctx.fillStyle = gr;
        ctx.beginPath(); ctx.arc(G.cx, G.cy, G.R, 0, TAU); ctx.fill();
        ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(' + ink.join(',') + ',.15)'; ctx.stroke();
      }
      ctx.fillStyle = INK;
      for (var i = 0, o = 0; i < P.n; i++, o += 5) {
        project(G, d[o], d[o + 1], d[o + 2], d[o + 3], d[o + 4], tmp);
        var z = tmp.z, a, s;
        if (t <= 0) {
          if (z <= 0) continue;
          a = 0.05 + 0.82 * smooth(0.04, 0.95, z); s = r * (0.3 + 0.7 * z);
        } else if (z > 0) {
          a = (0.05 + 0.82 * smooth(0.04, 0.95, z)) * (1 - t) + 0.6 * t; s = r * ((0.3 + 0.7 * z) * (1 - t) + t);
        } else {
          a = 0.6 * smooth(0.2, 0.9, t); s = r * t;
          if (a < 0.02) continue;
        }
        if (tmp.x < -4 || tmp.x > W + 4 || tmp.y < -4 || tmp.y > H + 4) continue;
        ctx.globalAlpha = a * ia;
        ctx.fillRect(tmp.x - s, tmp.y - s, 2 * s, 2 * s);
      }
      ctx.globalAlpha = 1;
    }

    function isSel(c) { return !!sel && c.members.some(function (g) { return g.key === sel.head; }); }
    function isHot(c) { return !!hot && c.members.some(function (g) { return g.key === hot; }); }
    function square(x, y, s, filled, label, back) {
      var h = s / 2;
      ctx.fillStyle = PAPER;
      ctx.fillRect(x - h - 1.5, y - h - 1.5, s + 3, s + 3);
      if (filled && !back) {
        ctx.fillStyle = INK;
        ctx.fillRect(x - h, y - h, s, s);
      } else {
        ctx.lineWidth = 1.25;
        ctx.strokeStyle = INK;
        ctx.strokeRect(x - h + 0.625, y - h + 0.625, s - 1.25, s - 1.25);
      }
      if (label) {
        ctx.fillStyle = filled ? PAPER : INK;
        ctx.fillText(label, x, y + 0.5);
      }
    }
    function drawMarkers(G, ia, ts) {
      var unit = small ? 8 : 7, selC = null, hovC = null;
      clusters.forEach(function (c) {
        var h = c.head;
        project(G, h.sp, h.cp, h.lng * DEG, h.fc, h.fy, tmp);
        c.sx = tmp.x; c.sy = tmp.y; c.z = tmp.z;
        var a = G.t <= 0 ? smooth(0.0, 0.26, tmp.z) : (tmp.z > 0 ? 1 : smooth(0.3, 0.9, G.t));
        c.a = (tmp.x < -24 || tmp.x > W + 24 || tmp.y < -24 || tmp.y > H + 24) ? 0 : a * ia;
        c.k = 0.8 + 0.2 * (G.t <= 0 ? smooth(0, 0.45, tmp.z) : 1);
      });
      var order = clusters.slice().sort(function (p, q) { return p.z - q.z; });
      ctx.font = '600 ' + (small ? 10 : 9.5) + 'px "Roboto Mono", "Space Mono", ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      order.forEach(function (c) {
        if (c.a <= 0.03) { c.s = 0; return; }
        var on = isSel(c), hi = on || hover === c.key || isHot(c);
        if (on) selC = c;
        if (hover === c.key) hovC = c;
        var k = c.k * (hi ? 1.18 : 1), s;
        ctx.globalAlpha = c.a;
        if (c.n === 1) {
          s = unit * k;
          square(c.sx, c.sy, s, c.exact, null, false);
        } else {
          var label = String(c.n);
          s = Math.max(unit * 2.1, ctx.measureText(label).width + 9) * k;
          if (c.members.length > 1) square(c.sx + 3, c.sy - 3, s, c.exact, null, true);
          square(c.sx, c.sy, s, c.exact, label, false);
        }
        c.s = s;
      });
      ctx.globalAlpha = 1;
      var named = labels(ia);
      if (selC) {
        var s2 = selC.s + 12;
        ctx.globalAlpha = selC.a;
        ctx.lineWidth = 1;
        ctx.strokeStyle = INK;
        ctx.strokeRect(Math.round(selC.sx - s2 / 2) + 0.5, Math.round(selC.sy - s2 / 2) + 0.5, Math.round(s2) - 1, Math.round(s2) - 1);
        if (pulse) {
          var p = clamp((ts - pulse) / 1000, 0, 1), s3 = s2 + 22 * easeOut(p);
          ctx.globalAlpha = selC.a * (1 - p) * 0.55;
          ctx.strokeRect(selC.sx - s3 / 2, selC.sy - s3 / 2, s3, s3);
        }
        ctx.globalAlpha = 1;
        leader(selC);
      }
      if (hovC && !selC && !(named && named.indexOf(hovC) !== -1)) tooltip(hovC);
    }

    /* Zoomé : le nom des lieux à côté des repères, comme sur un atlas (jamais l'un sur l'autre) */
    function labels(ia) {
      var la = smooth(1.7, 2.1, view.zoom) * ia;
      if (la < 0.03) return null;
      ctx.font = '500 9.5px "Roboto Mono", "Space Mono", ui-monospace, monospace';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.lineJoin = 'round';
      var boxes = [], done = [];
      clusters.forEach(function (c) {
        if (c.s && c.a > 0.3) boxes.push({ l: c.sx - c.s / 2 - 4, r: c.sx + c.s / 2 + 4, t: c.sy - c.s / 2 - 4, b: c.sy + c.s / 2 + 4 });
      });
      clusters.filter(function (c) { return c.s && c.a > 0.5 && c.members.length === 1 && c.head.label; })
        .sort(function (p, q) { return q.n - p.n; })
        .forEach(function (c) {
          var it0 = c.head.items[0], text = String((c.head.exact && it0.c) || c.head.label).toUpperCase(), w = ctx.measureText(text).width;
          var xs = [c.sx + c.s / 2 + 7, c.sx - c.s / 2 - 7 - w], edge = isZoomed ? 42 : 6;
          for (var i = 0; i < xs.length; i++) {
            var bx = { l: xs[i] - 2, r: xs[i] + w + 2, t: c.sy - 7, b: c.sy + 7 };
            if (bx.l < edge || bx.r > W - edge || bx.t < edge * 0.6 || bx.b > H - edge * 0.6) continue;
            if (boxes.some(function (o) { return bx.l < o.r && bx.r > o.l && bx.t < o.b && bx.b > o.t; })) continue;
            boxes.push(bx);
            done.push(c);
            ctx.globalAlpha = la * c.a;
            ctx.lineWidth = 3;
            ctx.strokeStyle = 'rgba(' + paper.join(',') + ',.9)';
            ctx.strokeText(text, xs[i], c.sy + 0.5);
            ctx.fillStyle = 'rgba(' + ink.join(',') + ',.82)';
            ctx.fillText(text, xs[i], c.sy + 0.5);
            break;
          }
        });
      ctx.globalAlpha = 1;
      ctx.textAlign = 'center';
      return done;
    }

    /* Survol (souris) : le nom du lieu, dans une étiquette */
    function clusterLabel(c) {
      if (c.members.length === 1) return c.head.label + (c.n > 1 ? ' · ' + nb(c.n, cfg.photos || 'photos') : '');
      return nb(c.members.length, cfg.places || 'lieux') + ' · ' + nb(c.n, cfg.photos || 'photos');
    }
    function tooltip(c) {
      var text = clusterLabel(c).toUpperCase();
      ctx.font = '500 10px "Roboto Mono", "Space Mono", ui-monospace, monospace';
      ctx.textAlign = 'left';
      var w = ctx.measureText(text).width + 16, h = 24;
      var x = c.sx + c.s / 2 + 10, y = c.sy - h / 2;
      if (x + w > W - 4) x = c.sx - c.s / 2 - 10 - w;
      ctx.globalAlpha = c.a;
      ctx.fillStyle = PAPER;
      ctx.fillRect(x, y, w, h);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(' + ink.join(',') + ',.18)';
      ctx.strokeRect(x + 0.5, y + 0.5, w - 1, h - 1);
      ctx.fillStyle = INK;
      ctx.fillText(text, x + 8, y + h / 2 + 0.5);
      ctx.globalAlpha = 1;
      ctx.textAlign = 'center';
    }

    /* Trait vers le cartel (grand écran) */
    function leader(c) {
      if (small || !cartel || cartel.hidden || !cartelBox || c.a < 0.3) return;
      var b = cartelBox, left = cartel.classList.contains('is-left');
      var x2 = left ? b.r + 10 : b.l - 10;
      var y2 = clamp(c.sy, b.t + 18, b.b - 18);
      if (left ? x2 > c.sx - 28 : x2 < c.sx + 28) return;
      var h = c.s / 2 + 6;
      ctx.globalAlpha = c.a * 0.7;
      ctx.lineWidth = 1;
      ctx.strokeStyle = INK;
      ctx.beginPath();
      ctx.moveTo(c.sx + (left ? -h : h), c.sy);
      ctx.lineTo(x2, y2);
      ctx.lineTo(x2 + (left ? -10 : 10), y2);
      ctx.stroke();
      ctx.globalAlpha = 1;
    }
    function measureCartel() {
      if (!cartel || cartel.hidden) { cartelBox = null; return; }
      var l = cartel.offsetLeft - canvas.offsetLeft, t = cartel.offsetTop - canvas.offsetTop;
      /* Le cartel est centré verticalement par une translation de -50 % (accueil : un panneau sur toute la hauteur, v3) */
      var hgt = cartel.offsetHeight;
      if (!small && !isHome) t -= hgt / 2;
      cartelBox = { l: l, t: t, r: l + cartel.offsetWidth, b: t + hgt };
    }

    /* 4. Mouvement : animations, élan, rotation lente */
    function autoOK(ts) {
      return mode === 'globe' && !reduce && !sel && !gesture && inView && !document.hidden && cfg.auto !== false && ts - lastUser > 3200;
    }
    function step(ts, dt) {
      var busy = false;
      if (tween) {
        var k = clamp((ts - tween.start) / tween.dur, 0, 1), e = ease(k), f = tween.from, to = tween.to, ch = tween.ch;
        if (ch.lon) view.lon = wrapDeg(f.lon + (to.lon - f.lon) * e);
        if (ch.lat) view.lat = f.lat + (to.lat - f.lat) * e;
        if (ch.zoom) view.zoom = f.zoom + (to.zoom - f.zoom) * e;
        if (ch.t) view.t = f.t + (to.t - f.t) * k;
        if (ch.ox) view.ox = f.ox + (to.ox - f.ox) * e;
        if (k >= 1) { tween = null; hint(); }
        busy = true;
      }
      /* Molette : la vue rejoint le zoom visé en douceur, environ 0,2 s (v4, 21/10) */
      if (zoomGoal) {
        var zg = clamp(zoomGoal, 1, maxZoom());
        view.zoom = Math.exp(Math.log(view.zoom) + (Math.log(zg) - Math.log(view.zoom)) * (1 - Math.exp(-dt / 0.07)));
        if (Math.abs(zg / view.zoom - 1) < 0.002) { view.zoom = zg; zoomGoal = 0; hint(); }
        busy = true;
      }
      if (!gesture && !(tween && (tween.ch.lon || tween.ch.lat))) {
        var target = autoOK(ts) ? -AUTO : 0;
        /* Un élan rapide s'amortit vite ; la reprise de la rotation lente, elle, est très douce */
        var fast = Math.abs(vel.lon) > Math.abs(target) && Math.abs(vel.lon - target) > 6;
        vel.lon += (target - vel.lon) * (1 - Math.exp(-dt / (fast ? 0.5 : 1.6)));
        vel.lat += -vel.lat * (1 - Math.exp(-dt / 0.45));
        if (!target && Math.abs(vel.lon) < 0.02) vel.lon = 0;
        if (Math.abs(vel.lat) < 0.02) vel.lat = 0;
        if (mode === 'flat' && view.zoom <= 1.05) vel.lat = 0;
        if (vel.lon || vel.lat) {
          view.lon = wrapDeg(view.lon + vel.lon * dt);
          view.lat = clamp(view.lat + vel.lat * dt, latMin(), latMax());
          busy = true;
        }
        if (target) busy = true;
      }
      if (introStart) busy = true;
      if (pulse && ts - pulse > 1050) pulse = 0;
      if (pulse) busy = true;
      return busy;
    }
    function tick(ts) {
      raf = 0;
      ts = ts || now();
      var dt = lastTs ? clamp((ts - lastTs) / 1000, 0, 0.05) : 1 / 60;
      lastTs = ts;
      var busy = step(ts, dt);
      render(ts);
      if (busy) raf = requestAnimationFrame(tick); else lastTs = 0;
    }
    function kick() { if (!raf && W) raf = requestAnimationFrame(tick); }
    function scheduleAuto() {
      clearTimeout(autoTimer);
      if (mode !== 'globe' || reduce) return;
      autoTimer = setTimeout(kick, 3300);
    }

    function setTween(to, dur) {
      var cur = { lon: view.lon, lat: view.lat, zoom: view.zoom, t: view.t, ox: view.ox };
      var prev = tween, target = {}, ch = {};
      ['lon', 'lat', 'zoom', 't', 'ox'].forEach(function (key) {
        if (to[key] != null) { target[key] = to[key]; ch[key] = true; }
        else if (prev && prev.ch[key]) { target[key] = prev.to[key]; ch[key] = true; }
        else { target[key] = cur[key]; ch[key] = false; }
      });
      /* Le dépliage suit toujours le mode choisi */
      var tm = mode === 'flat' ? 1 : 0;
      if (target.t !== tm) { target.t = tm; ch.t = true; }
      target.lon = cur.lon + wrapDeg(target.lon - cur.lon);
      target.zoom = clamp(target.zoom, 1, maxZoom());
      if (tm) { var cl = clamp(target.lat, latMin(target.zoom), latMax(target.zoom)); if (cl !== target.lat) { target.lat = cl; ch.lat = true; } }
      if (ch.lon || ch.lat) vel.lon = vel.lat = 0;
      if (ch.zoom) zoomGoal = 0;
      if (reduce || !dur) {
        view.lon = wrapDeg(target.lon); view.lat = target.lat; view.zoom = target.zoom; view.t = target.t; view.ox = target.ox;
        tween = null; hint(); kick();
        return;
      }
      tween = { from: cur, to: target, ch: ch, start: now(), dur: dur };
      kick();
    }

    /* 5. Souris et doigt */
    function pointAt(e, r) { r = r || canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    function hit(p) {
      var best = null, bd = 1e9;
      clusters.forEach(function (c) {
        if (c.a < 0.35 || !c.s) return;
        var reach = Math.max(small ? 22 : 13, c.s / 2 + (small ? 10 : 5));
        var d = Math.max(Math.abs(c.sx - p.x), Math.abs(c.sy - p.y));
        if (d < reach && d < bd) { bd = d; best = c; }
      });
      return best;
    }
    function dpp(axis) {
      var G = geom();
      if (G.t < 0.5) return 1 / (G.R * DEG);
      return 1 / (G.F * (axis === 'x' ? EE_C0 : 1.25) * DEG);
    }
    function flatLocked() { return mode === 'flat' && view.zoom <= 1.05 && baseF() * 2 * EE_HALF_W <= W * 1.02; }
    /* À plat, la carte tourne aussi sans zoom (20/10, Max : « on peut pas faire tourner le globe à plat ») */
    function pan(dx, dy) {
      if (dx) { var d = -dx * dpp('x'); view.lon = wrapDeg(view.lon + d); lonAcc += d; }
      if (dy && (mode === 'globe' || view.zoom > 1.05)) view.lat = clamp(view.lat + dy * dpp('y'), latMin(), latMax());
    }
    /* Clarté (23/10, Max : « plus simples et plus claires ») : le dernier geste du visiteur sur le globe (appui, glisser,
       survol d'un lieu). La molette sans Ctrl n'affiche son aide que juste après : qui fait seulement défiler la page en
       passant sur l'Atlas n'est plus dérangé à chaque cran ; qui vient de toucher le globe et tente de zoomer, si. */
    var engagedAt = -1e9;
    function takeOver() {
      vel.lon = vel.lat = 0;
      if (tween) { tween.ch.lon = false; tween.ch.lat = false; }
    }
    function startDrag(id, p, type, ts) {
      gesture = { kind: 'drag', id: id, type: type, x0: p.x, y0: p.y, lx: p.x, ly: p.y, t0: ts, lt: ts, moved: false, samples: [] };
      lonAcc = view.lon;
    }
    function startPinch() {
      var ids = Object.keys(ptrs), a = ptrs[ids[0]], b = ptrs[ids[1]];
      takeOver();
      if (tween) tween.ch.zoom = false;
      zoomGoal = 0;
      canvas.classList.add('is-dragging');
      gesture = { kind: 'pinch', d0: Math.max(12, Math.hypot(a.x - b.x, a.y - b.y)), z0: view.zoom, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
    }
    canvas.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      engagedAt = now();
      if (nPtr >= 2 || ptrs[e.pointerId]) return;
      var ts = now();
      if (!nPtr) downRect = canvas.getBoundingClientRect();
      var p = pointAt(e, downRect);
      ptrs[e.pointerId] = { x: p.x, y: p.y };
      nPtr++;
      try { canvas.setPointerCapture(e.pointerId); } catch (err) { /* sans capture */ }
      /* Souris : on attrape le globe. Doigt : seul un élan rapide s'arrête (le doigt veut peut-être faire défiler la page) */
      if (e.pointerType === 'mouse' || Math.abs(vel.lon) > 12) takeOver();
      if (nPtr === 1) startDrag(e.pointerId, p, e.pointerType, ts);
      else startPinch();
      kick();
    });
    canvas.addEventListener('pointermove', function (e) {
      var pr = ptrs[e.pointerId];
      if (!pr) {
        if (e.pointerType === 'mouse' && !nPtr) {
          var hc = hit(pointAt(e)), hk = hc ? hc.key : null;
          if (hc) engagedAt = now();
          if (hk !== hover) { hover = hk; canvas.style.cursor = hc ? 'pointer' : ''; kick(); }
        }
        return;
      }
      var p = pointAt(e, downRect), ts = now();
      pr.x = p.x; pr.y = p.y;
      if (!gesture) return;
      if (gesture.kind === 'pinch') {
        var ids = Object.keys(ptrs);
        if (ids.length < 2) return;
        var a = ptrs[ids[0]], b = ptrs[ids[1]], g = gesture;
        var d = Math.max(12, Math.hypot(a.x - b.x, a.y - b.y)), mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        view.zoom = clamp(g.z0 * d / g.d0, 1, maxZoom());
        pan(mx - g.mx, my - g.my);
        g.mx = mx; g.my = my;
        lastUser = ts;
        hint();
        kick();
        return;
      }
      if (gesture.id !== e.pointerId) return;
      var dg = gesture;
      if (!dg.moved) {
        var mdx = p.x - dg.x0, mdy = p.y - dg.y0;
        if (dg.vertical || Math.hypot(mdx, mdy) < (dg.type === 'mouse' ? 4 : 9)) return;
        /* Au doigt, un geste surtout vertical fait défiler la page : le globe ne bouge pas et ne s'arrête pas */
        if (dg.type !== 'mouse' && Math.abs(mdy) > Math.abs(mdx) * 1.2) { dg.vertical = true; return; }
        dg.moved = true;
        takeOver();
        canvas.classList.add('is-dragging');
        if (hover) { hover = null; canvas.style.cursor = ''; }
        dg.samples.push({ t: dg.lt, lon: lonAcc, lat: view.lat });
      }
      pan(p.x - dg.lx, p.y - dg.ly);
      dg.lx = p.x; dg.ly = p.y; dg.lt = ts;
      dg.samples.push({ t: ts, lon: lonAcc, lat: view.lat });
      while (dg.samples.length > 2 && ts - dg.samples[0].t > 110) dg.samples.shift();
      lastUser = ts;
      kick();
    });
    function release(e, cancelled) {
      if (!ptrs[e.pointerId]) return;
      delete ptrs[e.pointerId];
      nPtr = Math.max(0, nPtr - 1);
      var ts = now();
      if (gesture && gesture.kind === 'pinch') {
        /* Il reste un doigt : il reprend la main, sans élan ni toucher */
        var ids = Object.keys(ptrs);
        if (ids.length === 1) { startDrag(+ids[0], ptrs[ids[0]], 'touch', ts); gesture.moved = true; }
        else { gesture = null; canvas.classList.remove('is-dragging'); }
        lastUser = ts;
        scheduleAuto();
        kick();
        return;
      }
      if (!gesture || gesture.id !== e.pointerId) return;
      var g = gesture;
      gesture = null;
      canvas.classList.remove('is-dragging');
      if (!g.moved) {
        if (!cancelled && ts - g.t0 < 700) {
          lastUser = ts;
          tap(pointAt(e, downRect));
          scheduleAuto();
        }
        kick();
        return;
      }
      lastUser = ts;
      if (!cancelled && !reduce && g.samples.length > 1) {
        var s0 = g.samples[0], s1 = g.samples[g.samples.length - 1], span = (s1.t - s0.t) / 1000;
        if (span > 0.012 && ts - s1.t < 70) {
          vel.lon = clamp((s1.lon - s0.lon) / span, -320, 320);
          vel.lat = clamp((s1.lat - s0.lat) / span, -160, 160);
        }
      }
      scheduleAuto();
      kick();
    }
    canvas.addEventListener('pointerup', function (e) { release(e, false); });
    canvas.addEventListener('pointercancel', function (e) { release(e, true); });
    canvas.addEventListener('lostpointercapture', function (e) { release(e, true); });
    canvas.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' && hover) { hover = null; canvas.style.cursor = ''; kick(); }
    });
    /* La molette seule fait défiler la page, et dit comment zoomer (comme une carte Google intégrée) */
    var wheelEl = null, wheelTimer = 0, blinkAt = 0, blinkTimer = 0;
    function wheelHint() {
      if (now() - engagedAt > 6000) return;
      /* Accueil, v5 (21/10, Max : « faut pas le montrer au milieu, ça vient cacher le globe […] il peut clignoter
         légèrement ») : plus de bulle au milieu du globe ; l'aide, en bas à gauche, clignote un peu */
      if (isHome) {
        if (!hintEl || now() - blinkAt < 2400) return;
        blinkAt = now();
        hintEl.classList.remove('is-blink');
        void hintEl.offsetWidth;
        hintEl.classList.add('is-blink');
        clearTimeout(blinkTimer);
        blinkTimer = setTimeout(function () { hintEl.classList.remove('is-blink'); }, 1300);
        return;
      }
      if (!frame || !cfg.wheel) return;
      if (!wheelEl) {
        wheelEl = el('p', 'bcm__wheel', String(cfg.wheel).replace('[touche]', KEY));
        wheelEl.setAttribute('aria-hidden', 'true');
        frame.appendChild(wheelEl);
      }
      wheelEl.classList.add('is-on');
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () { wheelEl.classList.remove('is-on'); }, 1500);
    }
    /* Pincer sur un pavé tactile d'ordinateur (molette + ctrl), ou ctrl / ⌘ + molette : zoom.
       v4 (21/10, Max : « sur ordi le zoom est pas fluide ») : un cran de souris (100 px) faisait sauter le zoom
       d'un coup (× 2,7, du globe entier au plus près en une image). Un cran compte désormais pour 35 px au plus
       (× 1,4), et la vue rejoint le zoom visé en douceur (step) ; le pavé, qui envoie de petits pas, garde sa vitesse. */
    var zoomGoal = 0;
    canvas.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && !e.metaKey) { if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) wheelHint(); return; }
      e.preventDefault();
      takeOver();
      if (tween) tween.ch.zoom = false;
      var dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? (H || 600) : 1);
      zoomGoal = clamp((zoomGoal || view.zoom) * Math.exp(-clamp(dy, -35, 35) * 0.01), 1, maxZoom());
      if (reduce) { view.zoom = zoomGoal; zoomGoal = 0; }
      lastUser = now();
      scheduleAuto();
      hint();
      kick();
    }, { passive: false });
    /* iPhone : pendant qu'on fait tourner ou qu'on pince le globe, la page ne défile pas et ne zoome pas.
       Un geste vertical, lui, reste au navigateur (la page défile normalement). */
    canvas.addEventListener('touchmove', function (e) {
      if (!e.cancelable) return;
      if (e.touches.length > 1 || (gesture && (gesture.kind === 'pinch' || (gesture.moved && !gesture.vertical)))) e.preventDefault();
    }, { passive: false });
    canvas.addEventListener('gesturestart', function (e) { e.preventDefault(); });

    /* Toucher un repère : un lieu ouvre son cartel ; plusieurs lieux proches rapprochent la vue */
    function zoomFor(c) {
      var dmin = Infinity, m = c.members;
      for (var i = 0; i < m.length; i++) for (var j = i + 1; j < m.length; j++) dmin = Math.min(dmin, ang(m[i], m[j]));
      var ppr1 = geom().ppr / view.zoom;
      return Math.min(maxZoom(), ((small ? 26 : 21) * 1.3) / Math.max(dmin, 1e-6) / Math.max(1, ppr1));
    }
    function tap(p) {
      var c = hit(p);
      if (!c) { if (sel) close(); return; }
      if (c.members.length > 1 && !isSel(c)) {
        var z = Math.min(zoomFor(c), view.zoom * 2.4);
        if (z > view.zoom * 1.15) {
          var x = 0, y = 0, zz = 0;
          c.members.forEach(function (g) { var w = g.items.length; x += g.ux * w; y += g.uy * w; zz += g.uz * w; });
          var lat = Math.atan2(zz, Math.hypot(x, y)) / DEG, lng = Math.atan2(y, x) / DEG;
          /* Accueil, v5 (21/10, Max : « des fois, ça zoome. Mais ça ne montre pas les images ») : la liste s'ouvre
             tout de suite, et la vue se rapproche en même temps */
          /* Page de l'Atlas aussi (26/10, a26-atlas-bugs, Max : « si c'est un lot de pays ça affiche pas tout de suite
             les cadres ») : plus de premier clic qui ne fait que zoomer */
          open(c, { lon: lng, lat: isHome ? lat : clamp(lat, latMin(), latMax()), zoom: z });
          return;
        }
      }
      open(c);
    }

    /* 6. Zones */
    function inZone(z, g) {
      if (!z.box) return true;
      return g.lng >= z.box[0] && g.lng <= z.box[2] && g.lat >= z.box[1] && g.lat <= z.box[3];
    }
    var zoneButtons = [];
    ZONES.forEach(function (z, i) {
      var n = 0;
      groups.forEach(function (g) { if (inZone(z, g)) n += g.items.length; });
      if ((z.box && !n) || !zonesBox) return;
      var b = el('button', 'bcm__zone');
      b.type = 'button';
      b.setAttribute('aria-pressed', 'false');
      b.appendChild(el('span', null, zoneLabels[i] || z.k));
      b.appendChild(el('sup', null, String(n)));
      b.addEventListener('click', function () { setZone(z.k, true); });
      b.dataset.k = z.k;
      zonesBox.appendChild(b);
      zoneButtons.push(b);
    });
    function zoneOf(k) { return ZONES.filter(function (x) { return x.k === k; })[0] || ZONES[0]; }
    var zoneK = 'monde';
    function setZone(k, animate) {
      var z = zoneOf(k);
      zoneK = z.k;
      zoneButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.k === z.k)); });
      lastUser = now();
      if (sel) close(true);
      setTween({ lon: z.lon, lat: mode === 'globe' ? z.lat : (z.zoom > 1 ? z.lat : 0), zoom: z.zoom, ox: 0 }, animate ? 1100 : 0);
      scheduleAuto();
    }

    /* 7. Globe ou à plat */
    var viewButtons = viewsBox ? [].slice.call(viewsBox.querySelectorAll('[data-bcm-view]')) : [];
    function hint() {
      if (!hintEl) return;
      var touch = !!(mqTouch && mqTouch.matches), txt;
      if (mode === 'flat') txt = flatLocked() ? (cfg.hintTap || cfg.hintFlat) : cfg.hintFlat;
      else txt = touch ? (cfg.hintTouch || cfg.hintGlobe) : cfg.hintGlobe;
      txt = String(txt || '').replace('[touche]', KEY);
      if (hintEl.textContent !== txt) hintEl.textContent = txt;
    }
    function setMode(m, animate) {
      mode = m === 'flat' ? 'flat' : 'globe';
      viewButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-bcm-view') === mode)); });
      root.classList.toggle('is-flat', mode === 'flat');
      lastUser = now();
      if (sel) close(true);
      var z = zoneOf(zoneK);
      setTween({ t: mode === 'flat' ? 1 : 0, lat: mode === 'flat' ? (z.zoom > 1 ? z.lat : 0) : z.lat, zoom: z.zoom, ox: 0 }, animate ? 1300 : 0);
      hint();
      scheduleAuto();
    }
    viewButtons.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-bcm-view'), true); });
    });

    /* 8. Cartel */
    /* Accueil, téléphone (v3) : la photo en plein écran ; la page dessous ne défile plus, et la section passe devant
       l'en-tête fixe (la section est un calque de rang 3, imposé avec !important ; l'en-tête est de rang 100) */
    var wrap = root.closest('.shopify-section') || root.parentElement, wrapZ = null;
    function lock(on) {
      document.documentElement.classList.toggle('bcm-lock', on);
      if (!wrap || !wrap.style) return;
      if (on && wrapZ === null) {
        wrapZ = [wrap.style.getPropertyValue('z-index'), wrap.style.getPropertyPriority('z-index')];
        wrap.style.setProperty('z-index', '1000', 'important');
      } else if (!on && wrapZ !== null) {
        if (wrapZ[0]) wrap.style.setProperty('z-index', wrapZ[0], wrapZ[1]); else wrap.style.removeProperty('z-index');
        wrapZ = null;
      }
    }
    /* Accueil, téléphone (23/10, Max : « quand on clique sur un pays il faut le drapeau et que pas que ça ouvre une
       fenêtre qui masque tout ») : plus de cartel ni de voile. Le pays touché allume son drapeau dans la rangée du haut,
       et un repère léger (drapeau, pays, nombre de photos) se pose sous le globe ; il ouvre l'Atlas sur ce pays */
    var pickEl = null;
    function pick(c, at) {
      var cc = c.head.items[0].cc;
      if (!pickEl) {
        pickEl = el('a', 'bcm__pick');
        pickEl.hidden = true;
        (frame || root).appendChild(pickEl);
      }
      var base = root.querySelector('.bcm__btn--main');
      pickEl.href = ((base && base.getAttribute('href')) || '/collections/all?view=carte').split('#')[0] + (cc ? '#pays-' + cc.toLowerCase() : '');
      pickEl.innerHTML = '';
      var fl = cc ? flag(cc) : '';
      if (fl) {
        var f = el('i', 'bcm__flag br-flag', fl);
        f.setAttribute('aria-hidden', 'true');
        pickEl.appendChild(f);
      }
      var n = (cc && countries[cc]) || c.n;
      pickEl.appendChild(el('span', 'bcm__pick-name', (cc && countryName(cc)) || c.head.label));
      pickEl.appendChild(el('span', 'bcm__pick-n', nb(n, cfg.photos || 'photos', PHOTO1 || cfg.photos || 'photo')));
      pickEl.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      pickEl.hidden = false;
      placePick();
      root.classList.add('is-picked');
      if (flagsEl) [].forEach.call(flagsEl.children, function (f) { f.classList.toggle('is-on', f.getAttribute('data-cc') === cc); });
      /* Le clic qui suit le toucher ne doit pas tomber sur le repère qui vient d'apparaître (voir open) */
      pickEl.style.pointerEvents = 'none';
      setTimeout(function () { if (pickEl) pickEl.style.pointerEvents = ''; }, 450);
      pulse = now();
      lastUser = pulse;
      /* Le globe amène le pays au milieu ; un groupe de lieux proches se rapproche aussi, comme avant */
      var to = {};
      if (at && at.zoom) to.zoom = Math.min(maxZoom(), Math.max(view.zoom, at.zoom));
      if (mode === 'globe') { to.lon = at ? at.lon : c.head.lng; to.lat = clamp(at ? at.lat : c.head.lat, -60, 70); }
      else if (at || view.zoom > 1.05) { to.lon = at ? at.lon : c.head.lng; to.lat = at ? at.lat : c.head.lat; }
      if (to.lon != null || to.zoom != null) setTween(to, 900); else kick();
    }
    /* Le repère se pose au pied du globe, à cheval sur son bord bas : il se lit avec le pays, sans le cacher */
    function placePick() {
      if (pickEl && !pickEl.hidden) pickEl.style.top = Math.max(0, canvas.offsetTop + canvas.offsetHeight - (pickEl.offsetHeight || 40) - 10) + 'px';
    }
    function unpick() {
      root.classList.remove('is-picked');
      if (pickEl) pickEl.hidden = true;
      if (flagsEl) [].forEach.call(flagsEl.children, function (f) { f.classList.remove('is-on'); });
    }
    function close(silent) {
      if (!sel) return;
      sel = null;
      pulse = 0;
      if (cartel) { cartel.hidden = true; cartel.innerHTML = ''; cartel.classList.remove('is-left', 'is-list', 'is-fit'); cartel.style.removeProperty('--bcm-fit'); }
      cartelBox = null;
      unpick();
      root.classList.remove('is-open');
      if (isHome) lock(false);
      /* Accueil, v5 (21/10, Max : « quand on sort, il faut que ça nous ramène sur la vue de loin […] du globe de loin ») */
      /* 26/10 (a26-atlas-bugs) : la croix rend la vue d'avant — le globe reste un globe, à sa place, à son zoom */
      var b0 = before;
      before = null;
      if (!silent && b0) setTween({ lon: b0.lon, lat: b0.lat, zoom: b0.zoom, ox: 0 }, 900);
      else if (!silent && isHome) {
        var zf = zoneOf(zoneK);
        setTween({ zoom: zf.zoom, lat: mode === 'globe' ? zf.lat : (zf.zoom > 1 ? zf.lat : 0), ox: 0 }, 900);
      } else if (!silent && view.ox) setTween({ ox: 0 }, 650);
      lastUser = now();
      scheduleAuto();
      kick();
    }
    function card(it, compact, withPlace) {
      var a = el('a', 'bcm__card' + (compact ? ' is-compact' : ''));
      a.href = it.u;
      var th = el('span', 'bcm__thumb');
      if (it.i) {
        var img = el('img');
        img.src = it.i; img.alt = ''; img.decoding = 'async'; img.width = 120; img.height = 150;
        /* Accueil (v3) : la photo s'ouvre en grand, il lui faut une image plus fine que la vignette de 400 px */
        if (isHome && /[?&]width=\d+/.test(it.i)) {
          img.srcset = [400, 800, 1200].map(function (n) { return it.i.replace(/([?&]width=)\d+/, '$1' + n) + ' ' + n + 'w'; }).join(', ');
          img.sizes = compact ? '(max-width: 749px) 45vw, 12vw' : '(max-width: 749px) 100vw, 25vw';
        }
        th.appendChild(img);
      }
      a.appendChild(th);
      var m = el('span', 'bcm__meta');
      if (it.r && !compact) m.appendChild(el('span', 'bcm__ref', it.r));
      m.appendChild(el('span', 'bcm__name', quoted(it.t)));
      /* Langues (28/10) : en japonais, le point reste en fin de ligne avec le lieu (insécable avant « · ») ; la ligne se coupe après 「、」 */
      if (!compact) m.appendChild(el('span', 'bcm__place', placeLabel(it) + (it.y ? (LANG2 === 'ja' ? ' · ' : ' · ') + it.y : '')));
      else if (withPlace) m.appendChild(el('span', 'bcm__place', shortPlace(it)));
      if (it.a) m.appendChild(el('span', 'bcm__artist', '@' + String(it.a).replace(/^@/, '')));
      /* Clarté (23/10) : le prix aussi dans la liste d'un lieu, comme dans le panneau d'une seule photo */
      if (it.p) m.appendChild(el('span', 'bcm__price', String(cfg.from || 'À partir de [prix]').replace('[prix]', money(it.p))));
      if (!compact) m.appendChild(el('span', 'bcm__see', cfg.see || 'Voir le tirage'));
      a.appendChild(m);
      return a;
    }
    function fill(c) {
      cartel.innerHTML = '';
      var x = el('button', 'bcm__close');
      x.type = 'button';
      x.setAttribute('aria-label', cfg.close || 'Fermer');
      x.addEventListener('click', function () { close(); });
      cartel.appendChild(x);
      var all = [];
      c.members.forEach(function (g) { g.items.forEach(function (it) { all.push(it); }); });
      cartel.classList.toggle('is-list', all.length > 1);
      if (all.length === 1) {
        /* Page Atlas : une seule photo, le pays et ses flèches au-dessus (a26-atlas-navigation) */
        if (!isHome && navOrder.length > 1) {
          var h1 = el('p', 'bcm__group bcm__group--one');
          h1.appendChild(el('span', null, all[0].country || countryName(all[0].cc)));
          h1.appendChild(navEl());
          cartel.appendChild(h1);
        }
        cartel.appendChild(card(all[0], false, false));
        return;
      }
      var head = el('p', 'bcm__group'), title;
      if (c.members.length === 1) title = c.head.label;
      else {
        var names = [];
        c.members.forEach(function (g) { var n = g.items[0].country; if (n && names.indexOf(n) === -1) names.push(n); });
        title = names.length && names.length <= 3 ? names.join(' · ') : nb(c.members.length, cfg.places || 'lieux');
      }
      head.appendChild(el('span', null, title));
      if (!isHome && navOrder.length > 1) head.appendChild(navEl());
      head.appendChild(el('span', null, nb(all.length, cfg.photos || 'photos', PHOTO1 || cfg.photos || 'photo')));
      cartel.appendChild(head);
      var list = el('div', 'bcm__list');
      /* Le lieu sous une carte seulement s'il apporte quelque chose : il varie d'une carte à l'autre et n'est pas déjà le titre */
      var seen = {}, distinct = 0;
      all.forEach(function (it) { var pl = shortPlace(it); if (pl && !seen[pl]) { seen[pl] = 1; distinct++; } });
      all.forEach(function (it) { list.appendChild(card(it, true, distinct > 1 && shortPlace(it) !== title)); });
      cartel.appendChild(list);
    }
    /* Accueil, v5 (21/10, Max : « quand il y en a trois […] ça a tendance à afficher un slider […] on peut augmenter
       légèrement ») : jusqu'à quatre photos (deux rangées), les vignettes rapetissent juste ce qu'il faut pour tout
       montrer sans barre de défilement ; au-delà, la grille défile comme avant */
    function fitList() {
      if (!cartel || !isHome) return;
      cartel.classList.remove('is-fit');
      cartel.style.removeProperty('--bcm-fit');
      var list = cartel.hidden || small ? null : cartel.querySelector('.bcm__list');
      if (!list || list.children.length > 4) return;
      var rows = Math.ceil(list.children.length / 2), over = list.scrollHeight - list.clientHeight;
      var img = list.querySelector('.bcm__thumb img'), h = img ? img.getBoundingClientRect().height : 0;
      if (over <= 0 || !h) return;
      var fit = Math.floor(h - (over + 8) / rows);
      if (fit < h * 0.55) return;
      cartel.style.setProperty('--bcm-fit', fit + 'px');
      cartel.classList.add('is-fit');
    }
    function sigOf(c) { return c.members.map(function (g) { return g.key; }).join('|'); }
    function open(c, at) {
      if (!cartel) return;
      /* Accueil (v5) : après le zoom, un lieu du groupe ouvert montre sa propre liste ; le même lieu, lui, referme */
      if (isSel(c) && sel.sig === sigOf(c)) { close(); return; }
      /* 26/10 (a26-atlas-bugs, Max : « je clique sur un pays puis sur la croix ») : la vue d'avant l'ouverture, que la croix rend */
      if (!sel) before = { lon: view.lon, lat: view.lat, zoom: view.zoom };
      sel = { head: c.head.key, sig: sigOf(c) };
      if (railApi) railApi.pick(c.head.items[0] && c.head.items[0].cc);
      if (isHome && small) { pick(c, at); return; }
      fill(c);
      cartel.hidden = false;
      root.classList.add('is-open');
      fitList();
      pulse = now();
      lastUser = pulse;
      var to = {};
      /* Accueil, v5 (21/10, Max : « ça montre une liste. Et puis après, donc en même temps, ça zoome ») : la vue se
         rapproche du lieu pendant que la liste s'ouvre */
      var zt = isHome || (at && at.zoom) ? Math.min(maxZoom(), Math.max(view.zoom, (at && at.zoom) || 1.8)) : 0;
      if (zt) to.zoom = zt;
      if (mode === 'globe') {
        to.lon = at ? at.lon : c.head.lng;
        to.lat = zt ? clamp(at ? at.lat : c.head.lat, -60, 70) : clamp(c.head.lat * 0.85, -35, 58);
        if (!small) {
          var cw = cartel.offsetWidth || 330, R = baseR() * view.zoom;
          to.ox = zt ? -(cw + 16) / 2 : -clamp(W / 2 + R + 24 - (W - cw - 16), 0, Math.max(0, W / 2 - R * 0.9));
        }
      } else {
        cartel.classList.toggle('is-left', !small && !isHome && c.sx > W / 2);
        if (zt) { to.lon = at ? at.lon : c.head.lng; to.lat = at ? at.lat : c.head.lat; }
        else if (view.zoom > 1.05) { to.lon = c.head.lng; to.lat = c.head.lat; }
        /* Accueil (v3, Max : « que ça décale et que ça les mette un peu plus en grand à droite ») : la photo s'ouvre dans
           un panneau à droite, la carte glisse à gauche et amène le lieu au milieu de ce qui reste visible */
        else if (isHome && !small) to.lon = c.head.lng;
        if (isHome && !small) to.ox = -((cartel.offsetWidth || 300) + 16) / 2;
      }
      measureCartel();
      if (to.lon != null || to.ox != null) setTween(to, 900); else kick();
      /* Accueil (v3) : le clic qui suit le toucher tomberait sur la photo qui vient de s'ouvrir sous le doigt (et ouvrirait
         le tirage) ; le panneau l'ignore un instant */
      if (isHome) {
        cartel.style.pointerEvents = 'none';
        setTimeout(function () { cartel.style.pointerEvents = ''; }, 450);
      }
      /* Accueil, téléphone (v3) : la photo s'ouvre en grand, sur tout l'écran ; la page dessous ne défile plus */
      if (small && isHome) lock(true);
      /* Téléphone : le cartel s'ouvre sous le globe ; on le fait apparaître s'il est hors de l'écran */
      else if (small && cartel.getBoundingClientRect) {
        var r = cartel.getBoundingClientRect(), vh = window.innerHeight || 0;
        if (vh && r.bottom > vh - 8) {
          try { window.scrollBy({ top: r.bottom - vh + 16, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, r.bottom - vh + 16); }
        }
      }
    }
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sel) close(); });
    /* Accueil, v5 (21/10, Max : « quand on clique à côté […] il faut que ça nous ramène sur la vue de loin ») : un clic
       dans le bloc, hors du panneau et hors du globe, referme et ramène au globe vu de loin (sur le globe : voir tap) */
    if (isHome) root.addEventListener('click', function (e) {
      if (!sel || !cartel || cartel.contains(e.target) || (pickEl && pickEl.contains(e.target)) || (rail && rail.contains(e.target)) || e.target === canvas || e.target === glCanvas) return;
      close();
    });

    /* 8 bis. 26/10 (a26-atlas-navigation, Max : « à côté du nom du pays avoir des flèches qui naviguent, suivant ou
       précédent ») : les pays dans l'ordre des drapeaux ; le globe tourne vers le pays, la rangée suit. Aussi au clavier
       (← →). Le téléphone n'en a pas (bisou-carte.css) : son défilement au doigt ne change pas */
    var navOrder = Object.keys(countries).filter(function (cc) { return groups.some(function (g) { return g.items[0].cc === cc; }); }).sort(function (a, b) {
      return (countries[b] - countries[a]) || countryName(a).localeCompare(countryName(b), 'fr');
    });
    var NAV_TXT = ({ fr: ['Pays précédent', 'Pays suivant'], es: ['País anterior', 'País siguiente'], ja: ['前の国', '次の国'] })[String(document.documentElement.lang || '').slice(0, 2).toLowerCase()] || ['Previous country', 'Next country'];
    function navEl() {
      var g = el('span', 'bcm__cnav');
      g.setAttribute('role', 'group');
      [-1, 1].forEach(function (dir) {
        var b = el('button', 'bcm__cnav-btn');
        b.type = 'button';
        b.setAttribute('aria-label', NAV_TXT[dir < 0 ? 0 : 1]);
        b.setAttribute('data-bcm-step', String(dir));
        b.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + (dir < 0 ? 'M10 3 5 8l5 5' : 'm6 3 5 5-5 5') + '"/></svg>';
        g.appendChild(b);
      });
      return g;
    }
    function curCountry() {
      if (sel && byKey[sel.head]) return byKey[sel.head].items[0].cc || '';
      return railApi ? railApi.cur() : '';
    }
    function stepCountry(dir) {
      var n = navOrder.length;
      if (!n) return;
      var i = navOrder.indexOf(curCountry()), cc = navOrder[i < 0 ? (dir > 0 ? 0 : n - 1) : (i + dir + n) % n];
      var hg = groups.filter(function (g) { return g.items[0].cc === cc; }).sort(function (a, b) { return b.items.length - a.items.length; });
      if (!hg.length) return;
      lastUser = now();
      /* Accueil, panneau fermé : le globe tourne vers le pays, la rangée montre ses tirages, rien ne s'ouvre */
      if (isHome && !sel) {
        if (railApi) railApi.pick(cc);
        setTween(mode === 'globe' ? { lon: hg[0].lng, lat: clamp(hg[0].lat * 0.85, -35, 58) } : { lon: hg[0].lng }, 900);
        scheduleAuto();
        return;
      }
      /* Un pays ouvert : le suivant s'ouvre à sa place ; la croix rend toujours la vue d'avant le premier */
      var b0 = before;
      close(true);
      open({ key: hg[0].key, head: hg[0], members: hg, n: hg.reduce(function (s, g) { return s + g.items.length; }, 0), exact: hg[0].exact, sx: W / 2, sy: H / 2, z: 0, a: 1, k: 1, s: 0 });
      if (b0) before = b0;
      var nb = cartel && cartel.querySelector('[data-bcm-step="' + dir + '"]');
      if (nb && cartel.contains(document.activeElement || null) === false) nb.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-bcm-step]');
      if (!b || !root.contains(b)) return;
      e.stopPropagation();
      stepCountry(Number(b.getAttribute('data-bcm-step')));
    }, true);
    root.addEventListener('keydown', function (e) {
      if ((e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target;
      if (!t || !t.closest || !t.closest('.bcm__cnav, .bcm__rail-head, .bcm__cartel') || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      e.preventDefault();
      stepCountry(e.key === 'ArrowLeft' ? -1 : 1);
    });

    /* 9. Index des lieux */
    if (indexBox) {
      var byCountry = {};
      groups.forEach(function (g) { g.items.forEach(function (it) { (byCountry[it.cc || '?'] = byCountry[it.cc || '?'] || []).push(it); }); });
      var ccs = Object.keys(byCountry).sort(function (a, b) {
        return (byCountry[b].length - byCountry[a].length) || countryName(a).localeCompare(countryName(b), 'fr');
      });
      if (cfg.index) indexBox.appendChild(el('p', 'bcm__index-title', cfg.index));
      var grid = el('div', 'bcm__index-grid');
      ccs.forEach(function (cc) {
        var col = el('div', 'bcm__country');
        var h = el('p', 'bcm__country-name');
        var nm = el('span'), fl = flag(cc);
        if (fl) {
          var f = el('i', 'bcm__flag br-flag', fl);
          f.setAttribute('aria-hidden', 'true');
          nm.appendChild(f);
        }
        nm.appendChild(document.createTextNode(countryName(cc)));
        h.appendChild(nm);
        h.appendChild(el('span', null, String(byCountry[cc].length)));
        col.appendChild(h);
        var ul = el('ul');
        byCountry[cc].sort(function (a, b) { return String(a.t).localeCompare(String(b.t), 'fr'); }).forEach(function (it) {
          var li = el('li');
          var a = el('a');
          a.href = it.u;
          a.appendChild(el('span', 'bcm__i-name', quoted(it.t)));
          if (it.c) a.appendChild(el('span', 'bcm__i-city', it.c));
          a.addEventListener('mouseenter', function () { hot = it.key; kick(); });
          a.addEventListener('mouseleave', function () { if (hot === it.key) { hot = null; kick(); } });
          li.appendChild(a);
          ul.appendChild(li);
        });
        col.appendChild(ul);
        grid.appendChild(col);
      });
      indexBox.appendChild(grid);
    }

    /* 9 bis. Accueil, 26/10 (Max : « voir les images en dessous comme pour Nouvelle sélection ») puis 28/10 (c28-atlas, Max :
       « 6 photos […] mettre le pays au-dessus de chaque photo […] si je suis sur Espagne, ça met les 3 espagnols au-dessus avec
       le drapeau. Et puis après, ça continue d'en mettre d'autres avec tous les drapeaux » ; « au clic, ça ouvre les tirages. Et en
       dessous, ça affiche des images en continu de différents pays qui tournent ») : un seul bandeau sous le globe, toutes les
       photos de l'Atlas, pays après pays, chacune sous son drapeau et son pays ; il glisse seul, lentement, en boucle. Toucher un
       pays (repère ou flèches de pays) met ses photos en tête, puis les autres suivent. Le tour du globe à la main ne change
       plus le bandeau (« quand ça tourne, ça fait un peu les trucs bizarres »). 28/10, 18 h 45 (c28b-atlas-bandeau, Max :
       « quand on appuie sur un des tirages, il faut que ça nous ouvre la page produit ») : toute la carte, photo comprise,
       ouvre le tirage ; le panneau de droite ne s'ouvre plus que depuis le globe. */
    var rail = isHome ? root.querySelector('[data-bcm-rail]') : null;
    var railApi = rail ? (function () {
      var track = rail.querySelector('[data-bcm-track]'), titleEl = rail.querySelector('[data-bcm-rail-title]');
      var allBtn = rail.querySelector('[data-bcm-rail-all]'), prev = rail.querySelector('[data-bcm-prev]'), next = rail.querySelector('[data-bcm-next]');
      var more = root.querySelector('[data-bcm-atlas]'), moreHref = more ? more.getAttribute('href') || '' : '';
      if (!track) return null;
      var byCc = {}, order, cur = null, swapT = 0, arT = 0, setW = 0;
      items.forEach(function (it) { if (it.lat != null && it.cc && it.u) (byCc[it.cc] = byCc[it.cc] || []).push(it); });
      order = Object.keys(byCc).sort(function (a, b) { return (byCc[b].length - byCc[a].length) || countryName(a).localeCompare(countryName(b), 'fr'); });
      if (!order.length) { rail.hidden = true; return null; }
      function imgW(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
      /* Le prix comme la boutique l'écrit (« 35 € », « €35 ») : le modèle vient du serveur ; « dès » seulement s'il varie */
      var m35 = '';
      if (cfg.m35) { var dec = document.createElement('textarea'); dec.innerHTML = String(cfg.m35); m35 = dec.value; }
      function price(it) {
        var c = Number(it.p) || 0, m = c % 100 || !m35 ? money(c) : m35.replace('35', String(c / 100));
        if (!it.pv || !cfg.des) return m;
        return cfg.des.indexOf('[prix]') >= 0 ? cfg.des.replace('[prix]', m) : cfg.des + ' ' + m;
      }
      /* twin : la seconde suite de la boucle, cachée aux lecteurs d'écran et au clavier. La photo n'a plus de bouton à elle :
         le lien du titre couvre toute la carte (.bct__link::after), un clic sur la photo ouvre donc le tirage */
      function card(it, twin) {
        var li = el('li', 'bcm__cell'), c = el('div', 'bct'), m = el('div', 'bct__media');
        li.setAttribute('data-cc', it.cc);
        var pays = el('p', 'bcm__cell-pays'), fl = flag(it.cc);
        if (fl) { var f = el('i', 'bcm__flag br-flag', fl); f.setAttribute('aria-hidden', 'true'); pays.appendChild(f); }
        pays.appendChild(el('span', null, countryName(it.cc)));
        li.appendChild(pays);
        if (it.i) {
          var img = el('img', 'bct__img');
          img.loading = 'lazy';
          img.decoding = 'async';
          img.draggable = false;
          img.alt = '';
          img.sizes = '(min-width: 2200px) 340px, (min-width: 1200px) calc((100vw - 120px) / 6), (min-width: 1000px) calc((100vw - 120px) / 5), (min-width: 700px) calc((100vw - 80px) / 3.2), 74vw';
          img.srcset = [360, 533, 720, 940].map(function (w) { return imgW(it.i, w) + ' ' + w + 'w'; }).join(', ');
          img.src = imgW(it.i, 533);
          m.appendChild(img);
        }
        c.appendChild(m);
        var info = el('div', 'bct__info'), h = el('h3', 'bct__title'), a = el('a', 'bct__link');
        a.href = it.u;
        a.appendChild(el('span', 'bct__name', it.t || ''));
        h.appendChild(a);
        info.appendChild(h);
        if (it.a) info.appendChild(el('p', 'bct__artist', it.a));
        if (it.p) info.appendChild(el('p', 'bct__prix', price(it)));
        c.appendChild(info);
        li.appendChild(c);
        if (twin) { li.setAttribute('aria-hidden', 'true'); a.tabIndex = -1; }
        return li;
      }
      /* Le pays choisi d'abord, puis les autres mêlés : chaque pays réparti sur toute la suite (la France, 17 photos, ne
         remplit plus le bandeau des minutes entières), à égalité dans l'ordre des pays ; deux fois, pour boucler sans saut */
      function build(cc) {
        var list = cc ? byCc[cc].slice() : [], rest = [];
        order.forEach(function (k, o) { if (k !== cc) byCc[k].forEach(function (it, i) { rest.push({ it: it, k: (i + 0.5) / byCc[k].length, o: o }); }); });
        rest.sort(function (a, b) { return (a.k - b.k) || (a.o - b.o); });
        list = list.concat(rest.map(function (x) { return x.it; }));
        track.textContent = '';
        list.forEach(function (it) { track.appendChild(card(it)); });
        list.forEach(function (it) { track.appendChild(card(it, true)); });
        setW = 0;
      }
      /* La longueur d'une suite : arrivé à la seconde, on recule d'autant, et l'œil ne voit rien bouger */
      function span() {
        if (!setW) { var n = track.children.length / 2, a = track.children[0], b = track.children[n]; setW = a && b ? b.offsetLeft - a.offsetLeft : 0; }
        return setW;
      }
      function loops() { return span() > track.clientWidth + 2; }
      function arrows() {
        if (!prev || !next) return;
        if (loops()) { prev.removeAttribute('data-off'); next.removeAttribute('data-off'); }
        else { prev.setAttribute('data-off', ''); next.setAttribute('data-off', ''); }
      }
      function label() {
        if (!titleEl) return;
        titleEl.innerHTML = '';
        if (cur) {
          var fl = flag(cur), n = byCc[cur].length;
          if (fl) { var f = el('i', 'bcm__flag br-flag', fl); f.setAttribute('aria-hidden', 'true'); titleEl.appendChild(f); }
          titleEl.appendChild(el('span', null, countryName(cur)));
          titleEl.appendChild(el('span', 'bcm__rail-n', nb(n, cfg.photos || 'photos', PHOTO1 || cfg.photos || 'photo')));
        } else titleEl.appendChild(el('span', null, cfg.railAll || ''));
        if (allBtn) allBtn.hidden = !cur;
        /* « Voir l'Atlas » ouvre l'Atlas sur le pays montré */
        if (more && moreHref) more.setAttribute('href', moreHref.split('#')[0] + (cur ? '#pays-' + cur.toLowerCase() : ''));
      }
      function show(cc) {
        cc = cc && byCc[cc] ? cc : '';
        if (cc === cur) return;
        var first = cur === null;
        cur = cc;
        function apply() {
          build(cc);
          track.scrollLeft = 0;
          pos = 0;
          label();
          arrows();
          eager();
        }
        clearTimeout(swapT);
        /* Le pays choisi reste en tête un moment avant que le bandeau reparte */
        if (!first) hold(4200);
        if (first || reduce) { apply(); rail.classList.remove('is-swap'); return; }
        /* Un fondu court, sans saut : la rangée s'efface, change, revient */
        rail.classList.add('is-swap');
        swapT = setTimeout(function () { apply(); rail.classList.remove('is-swap'); }, 180);
      }
      track.addEventListener('scroll', function () { if (!arT) arT = requestAnimationFrame(function () { arT = 0; arrows(); }); }, { passive: true });
      /* Au téléphone, comme « Nouvelle sélection » (r26-accueil-defilement) : quand la rangée approche, les images des cartes
         se chargent d'avance (pas de carte grise sous le doigt) */
      var near = false;
      function eager() { if (near) [].forEach.call(track.querySelectorAll('.bcm__cell:not([aria-hidden]) img[loading="lazy"]'), function (img) { img.loading = 'eager'; }); }
      if ('IntersectionObserver' in window && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        var nearIo = new IntersectionObserver(function (en) {
          if (!en.some(function (x) { return x.isIntersecting; })) return;
          near = true;
          eager();
          nearIo.disconnect();
        }, { rootMargin: '100% 0px' });
        nearIo.observe(track);
      }
      /* Le glissement seul : lent, régulier, en boucle ; il s'arrête sous la souris, au doigt, au clavier, panneau du
         téléphone ouvert ou bandeau hors de l'écran, et reprend un peu après ; rien si l'appareil demande moins de mouvement */
      var SPEED = 24, pos = 0, last = 0, seen = false, over = false, holdUntil = 0;
      function hold(ms) { holdUntil = Math.max(holdUntil, Date.now() + (ms || 2600)); }
      function canDrift() {
        return seen && !over && !drag && !document.hidden && Date.now() > holdUntil && !rail.classList.contains('is-swap') &&
          !kbd() && !(small && sel) && loops();
      }
      /* Le clavier dans le bandeau l’arrête ; une flèche cliquée à la souris garde le focus sans le montrer (Chrome) :
         le bandeau repart quand même (relecture c28-atlas : il restait figé après le premier clic) */
      function kbd() {
        var a = document.activeElement;
        if (!a || !rail.contains(a)) return false;
        try { return a.matches(':focus-visible'); } catch (e) { return true; }
      }
      function tick(ts) {
        requestAnimationFrame(tick);
        var dt = last ? Math.min(50, ts - last) : 0;
        last = ts;
        if (!canDrift()) { pos = track.scrollLeft; return; }
        if (Math.abs(track.scrollLeft - pos) > 3) pos = track.scrollLeft;
        rail.classList.add('is-auto');
        pos += SPEED * dt / 1000;
        var w = span();
        if (w && pos >= w) pos -= w;
        track.scrollLeft = pos;
      }
      var box = track.parentNode;
      box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') over = true; });
      box.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { over = false; hold(900); } });
      /* Au doigt, l'aimantation revient le temps du geste : chaque geste finit sur une carte. Seulement quand le doigt glisse
         de côté : rendue dès le toucher, elle décalait la rangée sous le doigt (jusqu'à une demi-carte) et le toucher pouvait
         ouvrir la photo voisine (relecture c28-atlas) */
      var tx = null;
      track.addEventListener('touchstart', function (e) { hold(5000); tx = e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        hold(5000);
        if (tx !== null && e.touches[0] && Math.abs(e.touches[0].clientX - tx) > 8) { tx = null; rail.classList.remove('is-auto'); }
      }, { passive: true });
      track.addEventListener('touchend', function () { hold(5000); tx = null; }, { passive: true });
      /* Les flèches : d'une page, posées sur le bord d'une carte ; aux bouts, la boucle recule ou avance d'une suite */
      function by(dir) {
        hold(3200);
        var w = span(), n = track.children.length / 2, pitch = n ? w / n : 0, l = track.scrollLeft, step = track.clientWidth * 0.8;
        if (w) {
          if (dir > 0 && l + step > 2 * w - track.clientWidth) { l -= w; track.scrollLeft = l; }
          if (dir < 0 && l - step < 0) { l += w; track.scrollLeft = l; }
        }
        var to = l + dir * step;
        if (pitch) to = Math.round(to / pitch) * pitch;
        pos = to;
        try { track.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = to; }
      }
      if (prev) prev.addEventListener('click', function () { by(-1); });
      if (next) next.addEventListener('click', function () { by(1); });
      /* 26/10 (a26-atlas-navigation, Max : « les cartes qui s'affichent en dessous, j'aimerais pouvoir les faire défiler
         avec la souris ») : on la fait glisser à la souris ; le doigt reste natif. 28/10, 18 h 45 (c28b-atlas-bandeau, Max :
         « je veux pas que le scroll il fasse défiler horizontalement […] sinon ça vient couper la fluidité de la page ») :
         la molette et le pavé tactile font défiler la page, jamais la rangée (à la souris, la rangée n'est plus défilable
         à la main : section, overflow-x:hidden) ; restent les flèches, le glisser et le glissement seul */
      var snapT = 0, from = null;
      function free() {
        hold(3200);
        if (from === null) from = track.scrollLeft;
        rail.classList.add('is-free');
        clearTimeout(snapT);
        snapT = setTimeout(settle, 220);
      }
      /* Le geste fini, la rangée se pose sur la carte suivante dans le sens du geste (sinon, sur grand écran, trois crans
         revenaient à la carte de départ), puis l'aimantation revient */
      function settle() {
        var l = track.scrollLeft, max = track.scrollWidth - track.clientWidth, dir = l > from + 2 ? 1 : l < from - 2 ? -1 : 0, x = null;
        from = null;
        if (dir && l > 1 && l < max - 1) {
          var x0 = track.getBoundingClientRect().left - l;
          [].forEach.call(track.children, function (c) {
            var r = c.getBoundingClientRect();
            if (!r.width) return;
            var p = r.left - x0;
            if (dir > 0 ? p > l + 1 && (x === null || p < x) : p < l - 1 && (x === null || p > x)) x = p;
          });
        }
        if (x === null) { rail.classList.remove('is-free'); return; }
        track.scrollTo({ left: Math.max(0, Math.min(max, x)), behavior: reduce ? 'auto' : 'smooth' });
        snapT = setTimeout(function () { rail.classList.remove('is-free'); }, reduce ? 0 : 600);
      }
      var drag = null, dragged = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { id: e.pointerId, x: e.clientX, l: track.scrollLeft, on: false };
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag || drag.id !== e.pointerId) return;
        var dx = e.clientX - drag.x;
        if (!drag.on) {
          if (Math.abs(dx) < 6) return;
          drag.on = true;
          try { track.setPointerCapture(e.pointerId); } catch (er) { /* rien */ }
          rail.classList.add('is-drag');
        }
        free();
        track.scrollLeft = drag.l - dx;
      });
      function endDrag(e) {
        if (!drag || drag.id !== e.pointerId) return;
        if (drag.on) { dragged = Date.now(); rail.classList.remove('is-drag'); free(); }
        drag = null;
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      /* Le clic qui finit un glisser n'ouvre pas le tirage */
      track.addEventListener('click', function (e) { if (Date.now() - dragged < 300) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      /* Les flèches de pays, à côté du nom (8 bis) */
      if (titleEl && navOrder.length > 1) titleEl.parentNode.insertBefore(navEl(), titleEl.nextSibling);
      if (allBtn) allBtn.addEventListener('click', function () { show(''); if (sel) close(); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { setW = 0; arrows(); }).observe(track);
      show('');
      if (!reduce) {
        if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en.some(function (x) { return x.isIntersecting; }); }).observe(track);
        else seen = true;
        requestAnimationFrame(tick);
      }
      return {
        cur: function () { return cur || ''; },
        /* Toucher un pays (repère du globe, flèches de pays) */
        pick: function (cc) { show(cc); }
      };
    })() : null;

    /* 10. Taille : on ne touche aux canevas que si leur taille change vraiment
       (sur téléphone, la barre d'adresse qui apparaît ne doit pas effacer le globe) */
    function size() {
      var w = Math.round(canvas.clientWidth), h = Math.round(canvas.clientHeight);
      if (!w || !h) return;
      var sm = !!(mqSmall && mqSmall.matches), d = Math.min(2, window.devicePixelRatio || 1);
      if (w === W && h === H && d === dpr && sm === small) return;
      W = w; H = h; dpr = d; small = sm;
      /* Le repère d'un pays (téléphone, 23/10) ne bloque pas la page : seul le cartel ouvert en plein écran la bloque */
      if (isHome && sel) lock(small && !!cartel && !cartel.hidden);
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      if (glr && glCanvas) {
        var gd = Math.min(2.5, window.devicePixelRatio || 1);
        glCanvas.style.left = canvas.offsetLeft + 'px';
        glCanvas.style.top = canvas.offsetTop + 'px';
        glCanvas.style.width = W + 'px';
        glCanvas.style.height = H + 'px';
        glr.resize(Math.round(W * gd), Math.round(H * gd));
      }
      clusterScale = 0;
      fitList();
      placePick();
      measureCartel();
      hint();
      render(now());
      kick();
    }

    /* 11. Départ */
    /* La couche la plus fine (zoom) se prépare en avance, quand le navigateur est libre */
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      var f = function () { try { decode(LAYERS[LAYERS.length - 1]); } catch (e) { /* tant pis : décodée au besoin */ } };
      if (window.requestIdleCallback) window.requestIdleCallback(f, { timeout: 4000 }); else setTimeout(f, 2500);
    }
    function startIntro() {
      warm();
      if (introDone || introStart) return;
      introStart = now();
      /* À plat : la carte se pose, sans tourner (un glissement ferait voir la couture des bords) */
      if (mode !== 'globe') { var z0 = view.zoom; view.zoom = z0 * 1.06; setTween({ zoom: z0 }, 1500); return; }
      var to = view.lon;
      view.lon = wrapDeg(view.lon + 40);
      setTween({ lon: to }, 2000);
    }
    var startZone = (cfg.startZone && ZONES.some(function (z) { return z.k === cfg.startZone; })) ? cfg.startZone : 'monde';
    setZone(startZone, false);
    setMode(cfg.start === 'globe' ? 'globe' : 'flat', false);
    size();
    /* Venu du repère d'un pays sur l'accueil (23/10) : « #pays-fr » ouvre l'Atlas sur les photos de ce pays */
    var hm = !isHome && /^#pays-([a-z]{2})$/i.exec(window.location.hash || '');
    if (hm) {
      var hcc = hm[1].toUpperCase();
      var hg = groups.filter(function (g) { return g.items[0].cc === hcc; }).sort(function (a, b) { return b.items.length - a.items.length; });
      if (hg.length) {
        introDone = true;
        open({ key: hg[0].key, head: hg[0], members: hg, n: hg.reduce(function (s, g) { return s + g.items.length; }, 0), exact: hg[0].exact, sx: W / 2, sy: H / 2, z: 0, a: 1, k: 1, s: 0 });
      }
    }
    if ('ResizeObserver' in window) new ResizeObserver(function () { size(); }).observe(canvas);
    var rs = 0;
    window.addEventListener('resize', function () { clearTimeout(rs); rs = setTimeout(size, 150); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) { startIntro(); kick(); }
      }, { threshold: 0.12 }).observe(frame || canvas);
    } else {
      inView = true;
      startIntro();
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { lastTs = 0; kick(); } });
    /* Pour les tests seulement (réglage absent en boutique) */
    if (cfg.debug) {
      root.bcmDebug = function () {
        return {
          view: { lon: view.lon, lat: view.lat, zoom: view.zoom, t: view.t, ox: view.ox }, vel: { lon: vel.lon, lat: vel.lat },
          gl: !!glr, sel: sel && sel.head, tween: !!tween, gesture: gesture && gesture.kind, W: W, H: H, g: geom(), latRange: [latMin(), latMax()],
          clusters: clusters.map(function (c) { return { key: c.key, n: c.n, m: c.members.length, x: c.sx, y: c.sy, a: c.a, s: c.s }; })
        };
      };
    }
    /* Polices chargées après coup : on redessine les chiffres */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitList(); kick(); });
  }

  function start() { document.querySelectorAll('[data-bcm]').forEach(function (r) { try { init(r); } catch (e) { if (window.console) console.warn('[bcm]', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
